(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-core'.");
    }
    globalThis['kotlinx-serialization-kotlinx-serialization-core'] = factory(typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined' ? {} : globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.tc;
  var initMetadataForInterface = kotlin_kotlin.$_$.ub;
  var VOID = kotlin_kotlin.$_$.i;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.t4;
  var Unit_instance = kotlin_kotlin.$_$.e5;
  var emptyList = kotlin_kotlin.$_$.x6;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.l;
  var lazy = kotlin_kotlin.$_$.uh;
  var toString = kotlin_kotlin.$_$.xc;
  var initMetadataForClass = kotlin_kotlin.$_$.qb;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var KProperty1 = kotlin_kotlin.$_$.od;
  var getPropertyCallableRef = kotlin_kotlin.$_$.nb;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.s1;
  var objectCreate = kotlin_kotlin.$_$.sc;
  var captureStack = kotlin_kotlin.$_$.za;
  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.u1;
  var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.w1;
  var IllegalArgumentException = kotlin_kotlin.$_$.pg;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.d6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.o;
  var THROW_CCE = kotlin_kotlin.$_$.wg;
  var KClass = kotlin_kotlin.$_$.kd;
  var isInterface = kotlin_kotlin.$_$.gc;
  var Triple = kotlin_kotlin.$_$.zg;
  var getKClass = kotlin_kotlin.$_$.f;
  var Pair = kotlin_kotlin.$_$.tg;
  var Entry = kotlin_kotlin.$_$.p5;
  var KtMap = kotlin_kotlin.$_$.q5;
  var KtMutableMap = kotlin_kotlin.$_$.s5;
  var LinkedHashMap = kotlin_kotlin.$_$.m5;
  var HashMap = kotlin_kotlin.$_$.k5;
  var KtSet = kotlin_kotlin.$_$.v5;
  var KtMutableSet = kotlin_kotlin.$_$.t5;
  var LinkedHashSet = kotlin_kotlin.$_$.n5;
  var HashSet = kotlin_kotlin.$_$.l5;
  var Collection = kotlin_kotlin.$_$.j5;
  var KtList = kotlin_kotlin.$_$.o5;
  var KtMutableList = kotlin_kotlin.$_$.r5;
  var ArrayList = kotlin_kotlin.$_$.i5;
  var copyToArray = kotlin_kotlin.$_$.s6;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.a3;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.z2;
  var Result = kotlin_kotlin.$_$.ug;
  var ensureNotNull = kotlin_kotlin.$_$.ph;
  var equals = kotlin_kotlin.$_$.hb;
  var getStringHashCode = kotlin_kotlin.$_$.ob;
  var isBlank = kotlin_kotlin.$_$.ke;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.v1;
  var toList = kotlin_kotlin.$_$.o9;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.p;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.v;
  var toHashSet = kotlin_kotlin.$_$.k9;
  var toBooleanArray = kotlin_kotlin.$_$.j9;
  var withIndex = kotlin_kotlin.$_$.v9;
  var to = kotlin_kotlin.$_$.di;
  var toMap = kotlin_kotlin.$_$.p9;
  var lazy_0 = kotlin_kotlin.$_$.vh;
  var contentEquals = kotlin_kotlin.$_$.f6;
  var until = kotlin_kotlin.$_$.jd;
  var joinToString = kotlin_kotlin.$_$.r7;
  var initMetadataForObject = kotlin_kotlin.$_$.wb;
  var Long = kotlin_kotlin.$_$.rg;
  var Char = kotlin_kotlin.$_$.hg;
  var Duration__toIsoString_impl_9h6wsm = kotlin_kotlin.$_$.o2;
  var Duration = kotlin_kotlin.$_$.eg;
  var Companion_getInstance = kotlin_kotlin.$_$.v4;
  var Uuid = kotlin_kotlin.$_$.gg;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.w4;
  var toIntOrNull = kotlin_kotlin.$_$.nf;
  var hashCode = kotlin_kotlin.$_$.pb;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.z1;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.q;
  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.w;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.a1;
  var LinkedHashSet_init_$Create$_0 = kotlin_kotlin.$_$.b1;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.s;
  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.t;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.y;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.z;
  var isArray = kotlin_kotlin.$_$.yb;
  var arrayIterator = kotlin_kotlin.$_$.wa;
  var asList = kotlin_kotlin.$_$.z5;
  var step = kotlin_kotlin.$_$.id;
  var getValue = kotlin_kotlin.$_$.l7;
  var longArray = kotlin_kotlin.$_$.mc;
  var initMetadataForCompanion = kotlin_kotlin.$_$.rb;
  var get_lastIndex = kotlin_kotlin.$_$.t7;
  var countTrailingZeroBits = kotlin_kotlin.$_$.nh;
  var indexOf = kotlin_kotlin.$_$.m7;
  var contentToString = kotlin_kotlin.$_$.h6;
  var Enum = kotlin_kotlin.$_$.mg;
  var fillArrayVal = kotlin_kotlin.$_$.jb;
  var HashSet_init_$Create$_1 = kotlin_kotlin.$_$.u;
  var toString_0 = kotlin_kotlin.$_$.ci;
  var KTypeParameter = kotlin_kotlin.$_$.pd;
  var contentHashCode = kotlin_kotlin.$_$.g6;
  var booleanArray = kotlin_kotlin.$_$.ya;
  var emptyMap = kotlin_kotlin.$_$.y6;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.x4;
  var isCharArray = kotlin_kotlin.$_$.bc;
  var charArray = kotlin_kotlin.$_$.bb;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.p4;
  var isDoubleArray = kotlin_kotlin.$_$.dc;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.q4;
  var isFloatArray = kotlin_kotlin.$_$.ec;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.y4;
  var isLongArray = kotlin_kotlin.$_$.hc;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.c5;
  var _ULongArray___get_size__impl__ju6dtr = kotlin_kotlin.$_$.a4;
  var ULongArray = kotlin_kotlin.$_$.eh;
  var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.w3;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.t3;
  var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.y3;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.u3;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.r4;
  var isIntArray = kotlin_kotlin.$_$.fc;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.b5;
  var _UIntArray___get_size__impl__r6l8ci = kotlin_kotlin.$_$.r3;
  var UIntArray = kotlin_kotlin.$_$.ch;
  var _UIntArray___init__impl__ghjpc6 = kotlin_kotlin.$_$.n3;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.k3;
  var UIntArray__get_impl_gp5kza = kotlin_kotlin.$_$.p3;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.l3;
  var ShortCompanionObject_instance = kotlin_kotlin.$_$.s4;
  var isShortArray = kotlin_kotlin.$_$.ic;
  var Companion_getInstance_5 = kotlin_kotlin.$_$.d5;
  var _UShortArray___get_size__impl__jqto1b = kotlin_kotlin.$_$.j4;
  var UShortArray = kotlin_kotlin.$_$.gh;
  var _UShortArray___init__impl__9b26ef = kotlin_kotlin.$_$.f4;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.c4;
  var UShortArray__get_impl_fnbhmx = kotlin_kotlin.$_$.h4;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.d4;
  var ByteCompanionObject_instance = kotlin_kotlin.$_$.o4;
  var isByteArray = kotlin_kotlin.$_$.ac;
  var Companion_getInstance_6 = kotlin_kotlin.$_$.a5;
  var _UByteArray___get_size__impl__h6pkdv = kotlin_kotlin.$_$.i3;
  var UByteArray = kotlin_kotlin.$_$.ah;
  var _UByteArray___init__impl__ip4y9n = kotlin_kotlin.$_$.f3;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.b3;
  var UByteArray__get_impl_t5f3hv = kotlin_kotlin.$_$.g3;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.c3;
  var BooleanCompanionObject_instance = kotlin_kotlin.$_$.n4;
  var isBooleanArray = kotlin_kotlin.$_$.zb;
  var coerceAtLeast = kotlin_kotlin.$_$.dd;
  var copyOf = kotlin_kotlin.$_$.m6;
  var copyOf_0 = kotlin_kotlin.$_$.o6;
  var copyOf_1 = kotlin_kotlin.$_$.p6;
  var copyOf_2 = kotlin_kotlin.$_$.k6;
  var _ULongArray___get_storage__impl__28e64j = kotlin_kotlin.$_$.b4;
  var _ULongArray___init__impl__twm1l3_0 = kotlin_kotlin.$_$.x3;
  var ULongArray__set_impl_z19mvh = kotlin_kotlin.$_$.z3;
  var copyOf_3 = kotlin_kotlin.$_$.r6;
  var _UIntArray___get_storage__impl__92a0v0 = kotlin_kotlin.$_$.s3;
  var _UIntArray___init__impl__ghjpc6_0 = kotlin_kotlin.$_$.o3;
  var UIntArray__set_impl_7f2zu2 = kotlin_kotlin.$_$.q3;
  var copyOf_4 = kotlin_kotlin.$_$.j6;
  var _UShortArray___get_storage__impl__t2jpv5 = kotlin_kotlin.$_$.k4;
  var _UShortArray___init__impl__9b26ef_0 = kotlin_kotlin.$_$.g4;
  var UShortArray__set_impl_6d8whp = kotlin_kotlin.$_$.i4;
  var copyOf_5 = kotlin_kotlin.$_$.n6;
  var _UByteArray___get_storage__impl__d4kctt = kotlin_kotlin.$_$.j3;
  var _UByteArray___init__impl__ip4y9n_0 = kotlin_kotlin.$_$.e3;
  var UByteArray__set_impl_jvcicn = kotlin_kotlin.$_$.h3;
  var copyOf_6 = kotlin_kotlin.$_$.l6;
  var Unit = kotlin_kotlin.$_$.ih;
  var trimIndent = kotlin_kotlin.$_$.zf;
  var charSequenceLength = kotlin_kotlin.$_$.db;
  var lastOrNull = kotlin_kotlin.$_$.v7;
  var get_lastIndex_0 = kotlin_kotlin.$_$.u7;
  var ULong = kotlin_kotlin.$_$.fh;
  var UInt = kotlin_kotlin.$_$.dh;
  var UShort = kotlin_kotlin.$_$.hh;
  var UByte = kotlin_kotlin.$_$.bh;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.wh;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.u4;
  var mapOf = kotlin_kotlin.$_$.d8;
  var get_js = kotlin_kotlin.$_$.kc;
  var findAssociatedObject = kotlin_kotlin.$_$.d;
  var get_indices = kotlin_kotlin.$_$.o7;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.c2;
  var get_indices_0 = kotlin_kotlin.$_$.n7;
  var Companion_instance = kotlin_kotlin.$_$.z4;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.x2;
  var createFailure = kotlin_kotlin.$_$.oh;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
  initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
  initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
  initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForInterface(StringFormat, 'StringFormat');
  initMetadataForInterface(BinaryFormat, 'BinaryFormat');
  initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
  initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
  function get_isNullable() {
    return false;
  }
  function get_isInline() {
    return false;
  }
  function get_annotations() {
    return emptyList();
  }
  initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
  initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(elementDescriptors$1);
  initMetadataForClass(_no_name_provided__qut3iv);
  initMetadataForClass(elementNames$1);
  initMetadataForClass(_no_name_provided__qut3iv_0);
  initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
  initMetadataForInterface(CachedNames, 'CachedNames');
  initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(SerialKind, 'SerialKind');
  initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
  initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
  initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
  initMetadataForObject(SEALED, 'SEALED', VOID, PolymorphicKind);
  initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
  initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
  initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
  initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
  initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
  initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
  initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
  initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
  initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
  initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
  initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
  initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
  initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
  initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
  initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
  initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
  function decodeSerializableValue(deserializer) {
    return deserializer.pn(this);
  }
  initMetadataForInterface(Decoder, 'Decoder');
  function decodeSequentially() {
    return false;
  }
  function decodeCollectionSize(descriptor) {
    return -1;
  }
  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
    previousValue = previousValue === VOID ? null : previousValue;
    return $super === VOID ? this.fr(descriptor, index, deserializer, previousValue) : $super.fr.call(this, descriptor, index, deserializer, previousValue);
  }
  initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
  initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  function encodeNotNullMark() {
  }
  function beginCollection(descriptor, collectionSize) {
    return this.tq(descriptor);
  }
  function encodeSerializableValue(serializer, value) {
    serializer.on(this, value);
  }
  function encodeNullableSerializableValue(serializer, value) {
    var isNullabilitySupported = serializer.nn().so();
    if (isNullabilitySupported) {
      return this.ks(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
    }
    if (value == null) {
      this.nr();
    } else {
      this.ns();
      this.ks(serializer, value);
    }
  }
  initMetadataForInterface(Encoder, 'Encoder');
  function shouldEncodeElementDefault(descriptor, index) {
    return true;
  }
  initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
  initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UuidSerializer, 'UuidSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
  initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
  initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
  initMetadataForCompanion(Companion);
  initMetadataForClass(ElementMarker, 'ElementMarker');
  initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(EnumDescriptor, 'EnumDescriptor', VOID, PluginGeneratedSerialDescriptor);
  initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
  function typeParametersSerializers() {
    return get_EMPTY_SERIALIZER_ARRAY();
  }
  initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
  initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
  initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForInterface(SerializerFactory, 'SerializerFactory');
  initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer, PrimitiveArraySerializer]);
  initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
  initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
  initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
  initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
  initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerializersModule, 'SerializersModule');
  initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
  initMetadataForClass(ContextualProvider, 'ContextualProvider');
  initMetadataForClass(Argless, 'Argless', VOID, ContextualProvider);
  initMetadataForClass(WithTypeArguments, 'WithTypeArguments', VOID, ContextualProvider);
  function contextual(kClass, serializer) {
    return this.i17(kClass, SerializersModuleCollector$contextual$lambda(serializer));
  }
  initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
  initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
  initMetadataForClass(createCache$1);
  initMetadataForClass(createParametrizedCache$1);
  //endregion
  function KSerializer() {
  }
  function SerializationStrategy() {
  }
  function DeserializationStrategy() {
  }
  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.yn('type', serializer_1(StringCompanionObject_instance).nn());
      $this$buildSerialDescriptor.yn('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.zn_1.cb() + '>', CONTEXTUAL_getInstance(), []));
      $this$buildSerialDescriptor.sn_1 = this$0.ao_1;
      return Unit_instance;
    };
  }
  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
    return function () {
      var tmp = OPEN_getInstance();
      return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.zn_1);
    };
  }
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this.zn_1 = baseClass;
    this.ao_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.bo_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  protoOf(PolymorphicSerializer).co = function () {
    return this.zn_1;
  };
  protoOf(PolymorphicSerializer).nn = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.bo_1;
    descriptor$factory();
    return this_0.w();
  };
  protoOf(PolymorphicSerializer).toString = function () {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.zn_1) + ')';
  };
  function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.fo(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.co());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
    var tmp0_elvis_lhs = _this__u8e3s4.eo(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.co());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function descriptor$factory() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.nn();
    }, null);
  }
  function SealedClassSerializer() {
  }
  protoOf(SealedClassSerializer).nn = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.go_1;
    descriptor$factory_0();
    return this_0.w();
  };
  function descriptor$factory_0() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.nn();
    }, null);
  }
  function StringFormat() {
  }
  function BinaryFormat() {
  }
  function SerializationException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$() {
    var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$_0(message) {
    var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$_0);
    return tmp;
  }
  function SerializationException_init_$Init$_1(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, UnknownFieldException);
  }
  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
    MissingFieldException.call($this, missingFields, missingFields.j() === 1 ? "Field '" + missingFields.l(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
    return $this;
  }
  function MissingFieldException_init_$Create$(missingFields, serialName) {
    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException(missingFields, message, cause) {
    SerializationException_init_$Init$_1(message, cause, this);
    captureStack(this, MissingFieldException);
    this.mo_1 = missingFields;
  }
  function serializerOrNull(_this__u8e3s4) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator = typeArguments.g();
      while (tmp0_iterator.h()) {
        var item = tmp0_iterator.i();
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp$ret$0 = serializer(_this__u8e3s4, item);
        destination.e(tmp$ret$0);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var tmp0_iterator_0 = typeArguments.g();
      while (tmp0_iterator_0.h()) {
        var item_0 = tmp0_iterator_0.i();
        // Inline function 'kotlinx.serialization.serializersForParameters.<anonymous>' call
        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$3 = tmp_0;
        destination_0.e(tmp$ret$3);
      }
      tmp = destination_0;
    }
    var serializers = tmp;
    return serializers;
  }
  function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
  }
  function serializer(_this__u8e3s4, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerOrNull_0(_this__u8e3s4, type) {
    return serializerByKTypeImpl(_this__u8e3s4, type, false);
  }
  function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp;
    if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
      tmp = new ArrayListSerializer(serializers.l(0));
    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
      tmp = new HashSetSerializer(serializers.l(0));
    } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
      tmp = new LinkedHashSetSerializer(serializers.l(0));
    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
      tmp = new HashMapSerializer(serializers.l(0), serializers.l(1));
    } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
      tmp = new LinkedHashMapSerializer(serializers.l(0), serializers.l(1));
    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
      tmp = MapEntrySerializer(serializers.l(0), serializers.l(1));
    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
      tmp = PairSerializer(serializers.l(0), serializers.l(1));
    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
      tmp = TripleSerializer(serializers.l(0), serializers.l(1), serializers.l(2));
    } else {
      var tmp_0;
      if (isReferenceArray(_this__u8e3s4)) {
        var tmp_1 = elementClassifierIfArray();
        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.l(0));
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(serializers);
    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
  }
  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type.tb();
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.sb();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      var tmp$ret$0 = typeOrThrow(item);
      destination.e(tmp$ret$0);
    }
    var typeArguments = destination;
    var tmp;
    if (typeArguments.k()) {
      var tmp_0;
      if (isInterface_0(rootClass) && !(_this__u8e3s4.oo(rootClass) == null)) {
        tmp_0 = null;
      } else {
        tmp_0 = findCachedSerializer(rootClass, isNullable);
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (_this__u8e3s4.no()) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.Result.getOrNull' call
        var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
        var tmp_2;
        if (_Result___get_isFailure__impl__jpiriv(this_1)) {
          tmp_2 = null;
        } else {
          var tmp_3 = _Result___get_value__impl__bjfvqg(this_1);
          tmp_2 = (tmp_3 == null ? true : !(tmp_3 == null)) ? tmp_3 : THROW_CCE();
        }
        tmp_1 = tmp_2;
      }
      tmp = tmp_1;
    }
    var cachedSerializer = tmp;
    if (!(cachedSerializer == null))
      return cachedSerializer;
    var tmp_4;
    if (typeArguments.k()) {
      var tmp0_elvis_lhs = serializerOrNull(rootClass);
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.oo(rootClass) : tmp0_elvis_lhs;
      var tmp_5;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
        tmp_5 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
      } else {
        tmp_5 = tmp1_elvis_lhs;
      }
      tmp_4 = tmp_5;
    } else {
      var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
      var tmp_6;
      if (tmp2_elvis_lhs == null) {
        return null;
      } else {
        tmp_6 = tmp2_elvis_lhs;
      }
      var serializers = tmp_6;
      var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
      var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.po(rootClass, serializers) : tmp3_elvis_lhs;
      var tmp_7;
      if (tmp4_elvis_lhs == null) {
        // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
        tmp_7 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
      } else {
        tmp_7 = tmp4_elvis_lhs;
      }
      tmp_4 = tmp_7;
    }
    var contextualSerializer = tmp_4;
    var tmp_8;
    if (contextualSerializer == null) {
      tmp_8 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_8 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
    }
    var tmp6_safe_receiver = tmp_8;
    return tmp6_safe_receiver == null ? null : nullable(tmp6_safe_receiver, isNullable);
  }
  function nullable(_this__u8e3s4, shouldBeNullable) {
    if (shouldBeNullable)
      return get_nullable(_this__u8e3s4);
    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  }
  function serializer_0(_this__u8e3s4) {
    var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      serializerNotRegistered(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerByKTypeImpl$lambda($typeArguments) {
    return function () {
      return $typeArguments.l(0).rb();
    };
  }
  function get_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE;
  }
  var SERIALIZERS_CACHE;
  function get_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE_NULLABLE;
  }
  var SERIALIZERS_CACHE_NULLABLE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  function findCachedSerializer(clazz, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().qo(clazz);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
      }
      tmp = tmp_0;
    } else {
      tmp = get_SERIALIZERS_CACHE_NULLABLE().qo(clazz);
    }
    return tmp;
  }
  function findParametrizedCachedSerializer(clazz, types, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().ro(clazz, types);
      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
    } else {
      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().ro(clazz, types);
    }
    return tmp;
  }
  function SERIALIZERS_CACHE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_elvis_lhs = serializerOrNull(it);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_elvis_lhs = serializerOrNull(it);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_nullable(tmp1_safe_receiver);
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp2_safe_receiver, KSerializer) ? tmp2_safe_receiver : THROW_CCE();
    }
    return tmp_0;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
    return function () {
      return $types.l(0).rb();
    };
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
    return function () {
      return $types.l(0).rb();
    };
  }
  var properties_initialized_SerializersCache_kt_q8kf25;
  function _init_properties_SerializersCache_kt__hgwi2p() {
    if (!properties_initialized_SerializersCache_kt_q8kf25) {
      properties_initialized_SerializersCache_kt_q8kf25 = true;
      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
    }
  }
  function get_nullable(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.nn().so()) {
      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this__u8e3s4);
    }
    return tmp;
  }
  function serializer_1(_this__u8e3s4) {
    return StringSerializer_getInstance();
  }
  function serializer_2(_this__u8e3s4) {
    return CharSerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function serializer_3(_this__u8e3s4) {
    return DoubleSerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function serializer_4(_this__u8e3s4) {
    return FloatSerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function serializer_5(_this__u8e3s4) {
    return LongSerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function serializer_6(_this__u8e3s4) {
    return ULongSerializer_getInstance();
  }
  function ULongArraySerializer() {
    return ULongArraySerializer_getInstance();
  }
  function serializer_7(_this__u8e3s4) {
    return IntSerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function serializer_8(_this__u8e3s4) {
    return UIntSerializer_getInstance();
  }
  function UIntArraySerializer() {
    return UIntArraySerializer_getInstance();
  }
  function serializer_9(_this__u8e3s4) {
    return ShortSerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function serializer_10(_this__u8e3s4) {
    return UShortSerializer_getInstance();
  }
  function UShortArraySerializer() {
    return UShortArraySerializer_getInstance();
  }
  function serializer_11(_this__u8e3s4) {
    return ByteSerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function serializer_12(_this__u8e3s4) {
    return UByteSerializer_getInstance();
  }
  function UByteArraySerializer() {
    return UByteArraySerializer_getInstance();
  }
  function serializer_13(_this__u8e3s4) {
    return BooleanSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function serializer_14(_this__u8e3s4) {
    return UnitSerializer_getInstance();
  }
  function NothingSerializer() {
    return NothingSerializer_getInstance();
  }
  function serializer_15(_this__u8e3s4) {
    return DurationSerializer_getInstance();
  }
  function serializer_16(_this__u8e3s4) {
    return UuidSerializer_getInstance();
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function SetSerializer(elementSerializer) {
    return new LinkedHashSetSerializer(elementSerializer);
  }
  function withContext(_this__u8e3s4, context) {
    return new ContextDescriptor(_this__u8e3s4, context);
  }
  function ContextDescriptor(original, kClass) {
    this.to_1 = original;
    this.uo_1 = kClass;
    this.vo_1 = this.to_1.wo() + '<' + this.uo_1.cb() + '>';
  }
  protoOf(ContextDescriptor).wo = function () {
    return this.vo_1;
  };
  protoOf(ContextDescriptor).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.to_1, another.to_1) && another.uo_1.equals(this.uo_1);
  };
  protoOf(ContextDescriptor).hashCode = function () {
    var result = this.uo_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.vo_1) | 0;
    return result;
  };
  protoOf(ContextDescriptor).toString = function () {
    return 'ContextDescriptor(kClass: ' + toString(this.uo_1) + ', original: ' + toString(this.to_1) + ')';
  };
  protoOf(ContextDescriptor).xo = function () {
    return this.to_1.xo();
  };
  protoOf(ContextDescriptor).so = function () {
    return this.to_1.so();
  };
  protoOf(ContextDescriptor).yo = function () {
    return this.to_1.yo();
  };
  protoOf(ContextDescriptor).zo = function () {
    return this.to_1.zo();
  };
  protoOf(ContextDescriptor).ap = function () {
    return this.to_1.ap();
  };
  protoOf(ContextDescriptor).bp = function (index) {
    return this.to_1.bp(index);
  };
  protoOf(ContextDescriptor).cp = function (name) {
    return this.to_1.cp(name);
  };
  protoOf(ContextDescriptor).dp = function (index) {
    return this.to_1.dp(index);
  };
  protoOf(ContextDescriptor).ep = function (index) {
    return this.to_1.ep(index);
  };
  protoOf(ContextDescriptor).fp = function (index) {
    return this.to_1.fp(index);
  };
  function getContextualDescriptor(_this__u8e3s4, descriptor) {
    var tmp0_safe_receiver = get_capturedKClass(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.descriptors.getContextualDescriptor.<anonymous>' call
      var tmp0_safe_receiver_0 = _this__u8e3s4.oo(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.nn();
    }
    return tmp;
  }
  function get_capturedKClass(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ContextDescriptor) {
      tmp = _this__u8e3s4.uo_1;
    } else {
      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
        tmp = get_capturedKClass(_this__u8e3s4.gp_1);
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function SerialDescriptor() {
  }
  function get_elementDescriptors(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(_this__u8e3s4);
  }
  function get_elementNames(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(_this__u8e3s4);
  }
  function elementDescriptors$1($this_elementDescriptors) {
    this.kp_1 = $this_elementDescriptors;
    this.jp_1 = $this_elementDescriptors.zo();
  }
  protoOf(elementDescriptors$1).h = function () {
    return this.jp_1 > 0;
  };
  protoOf(elementDescriptors$1).i = function () {
    var tmp = this.kp_1.zo();
    var _unary__edvuaz = this.jp_1;
    this.jp_1 = _unary__edvuaz - 1 | 0;
    return this.kp_1.ep(tmp - _unary__edvuaz | 0);
  };
  function _no_name_provided__qut3iv($this_elementDescriptors) {
    this.lp_1 = $this_elementDescriptors;
  }
  protoOf(_no_name_provided__qut3iv).g = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
    return new elementDescriptors$1(this.lp_1);
  };
  function elementNames$1($this_elementNames) {
    this.np_1 = $this_elementNames;
    this.mp_1 = $this_elementNames.zo();
  }
  protoOf(elementNames$1).h = function () {
    return this.mp_1 > 0;
  };
  protoOf(elementNames$1).i = function () {
    var tmp = this.np_1.zo();
    var _unary__edvuaz = this.mp_1;
    this.mp_1 = _unary__edvuaz - 1 | 0;
    return this.np_1.bp(tmp - _unary__edvuaz | 0);
  };
  function _no_name_provided__qut3iv_0($this_elementNames) {
    this.op_1 = $this_elementNames;
  }
  protoOf(_no_name_provided__qut3iv_0).g = function () {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementNames>.<anonymous>' call
    return new elementNames$1(this.op_1);
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp;
    if (builder === VOID) {
      tmp = buildSerialDescriptor$lambda;
    } else {
      tmp = builder;
    }
    builder = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!equals(kind, CLASS_getInstance())) {
      // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder.tn_1.j(), toList(typeParameters), sdBuilder);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this.qn_1 = serialName;
    this.rn_1 = false;
    this.sn_1 = emptyList();
    this.tn_1 = ArrayList_init_$Create$_0();
    this.un_1 = HashSet_init_$Create$();
    this.vn_1 = ArrayList_init_$Create$_0();
    this.wn_1 = ArrayList_init_$Create$_0();
    this.xn_1 = ArrayList_init_$Create$_0();
  }
  protoOf(ClassSerialDescriptorBuilder).pp = function (elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.un_1.e(elementName)) {
      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
      var message = "Element with name '" + elementName + "' is already registered in " + this.qn_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.tn_1.e(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.vn_1.e(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.wn_1.e(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.xn_1.e(isOptional);
  };
  protoOf(ClassSerialDescriptorBuilder).yn = function (elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.pp(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.pp.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  };
  function _get__hashCode__tgwhef($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.bq_1;
    _hashCode$factory();
    return this_0.w();
  }
  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.aq_1);
    };
  }
  function SerialDescriptorImpl$toString$lambda(this$0) {
    return function (it) {
      return this$0.bp(it) + ': ' + this$0.ep(it).wo();
    };
  }
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this.qp_1 = serialName;
    this.rp_1 = kind;
    this.sp_1 = elementsCount;
    this.tp_1 = builder.sn_1;
    this.up_1 = toHashSet(builder.tn_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.tn_1;
    tmp.vp_1 = copyToArray(this_0);
    this.wp_1 = compactArray(builder.vn_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.wn_1;
    tmp_0.xp_1 = copyToArray(this_1);
    this.yp_1 = toBooleanArray(builder.xn_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.vp_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.g();
    while (tmp0_iterator.h()) {
      var item = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
      var tmp$ret$2 = to(item.kg_1, item.jg_1);
      destination.e(tmp$ret$2);
    }
    tmp_1.zp_1 = toMap(destination);
    this.aq_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.bq_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  protoOf(SerialDescriptorImpl).wo = function () {
    return this.qp_1;
  };
  protoOf(SerialDescriptorImpl).xo = function () {
    return this.rp_1;
  };
  protoOf(SerialDescriptorImpl).zo = function () {
    return this.sp_1;
  };
  protoOf(SerialDescriptorImpl).ap = function () {
    return this.tp_1;
  };
  protoOf(SerialDescriptorImpl).cq = function () {
    return this.up_1;
  };
  protoOf(SerialDescriptorImpl).bp = function (index) {
    return getChecked(this.vp_1, index);
  };
  protoOf(SerialDescriptorImpl).cp = function (name) {
    var tmp0_elvis_lhs = this.zp_1.b2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(SerialDescriptorImpl).dp = function (index) {
    return getChecked(this.xp_1, index);
  };
  protoOf(SerialDescriptorImpl).ep = function (index) {
    return getChecked(this.wp_1, index);
  };
  protoOf(SerialDescriptorImpl).fp = function (index) {
    return getChecked_0(this.yp_1, index);
  };
  protoOf(SerialDescriptorImpl).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.wo() === other.wo())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
      if (!contentEquals(this.aq_1, other.aq_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.zo() === other.zo())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.zo();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.ep(index).wo() === other.ep(index).wo())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.ep(index).xo(), other.ep(index).xo())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SerialDescriptorImpl).hashCode = function () {
    return _get__hashCode__tgwhef(this);
  };
  protoOf(SerialDescriptorImpl).toString = function () {
    var tmp = until(0, this.sp_1);
    var tmp_0 = this.qp_1 + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp;
    if (builderAction === VOID) {
      tmp = buildClassSerialDescriptor$lambda;
    } else {
      tmp = builderAction;
    }
    builderAction = tmp;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.buildClassSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.tn_1.j(), toList(typeParameters), sdBuilder);
  }
  function PrimitiveSerialDescriptor(serialName, kind) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (!!isBlank(serialName)) {
      // Inline function 'kotlinx.serialization.descriptors.PrimitiveSerialDescriptor.<anonymous>' call
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return PrimitiveDescriptorSafe(serialName, kind);
  }
  function buildSerialDescriptor$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function _hashCode$factory() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef(receiver);
    }, null);
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  protoOf(SerialKind).toString = function () {
    return ensureNotNull(getKClassFromExpression(this).cb());
  };
  protoOf(SerialKind).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  function SEALED() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  function AbstractDecoder() {
  }
  protoOf(AbstractDecoder).dq = function () {
    throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(AbstractDecoder).eq = function () {
    return true;
  };
  protoOf(AbstractDecoder).fq = function () {
    return null;
  };
  protoOf(AbstractDecoder).gq = function () {
    var tmp = this.dq();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).hq = function () {
    var tmp = this.dq();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).iq = function () {
    var tmp = this.dq();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).jq = function () {
    var tmp = this.dq();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).kq = function () {
    var tmp = this.dq();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).lq = function () {
    var tmp = this.dq();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).mq = function () {
    var tmp = this.dq();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).nq = function () {
    var tmp = this.dq();
    return tmp instanceof Char ? tmp.l1_1 : THROW_CCE();
  };
  protoOf(AbstractDecoder).oq = function () {
    var tmp = this.dq();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).pq = function (enumDescriptor) {
    var tmp = this.dq();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).qq = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).rq = function (deserializer, previousValue) {
    return this.sq(deserializer);
  };
  protoOf(AbstractDecoder).tq = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).uq = function (descriptor) {
  };
  protoOf(AbstractDecoder).vq = function (descriptor, index) {
    return this.gq();
  };
  protoOf(AbstractDecoder).wq = function (descriptor, index) {
    return this.hq();
  };
  protoOf(AbstractDecoder).xq = function (descriptor, index) {
    return this.iq();
  };
  protoOf(AbstractDecoder).yq = function (descriptor, index) {
    return this.jq();
  };
  protoOf(AbstractDecoder).zq = function (descriptor, index) {
    return this.kq();
  };
  protoOf(AbstractDecoder).ar = function (descriptor, index) {
    return this.lq();
  };
  protoOf(AbstractDecoder).br = function (descriptor, index) {
    return this.mq();
  };
  protoOf(AbstractDecoder).cr = function (descriptor, index) {
    return this.nq();
  };
  protoOf(AbstractDecoder).dr = function (descriptor, index) {
    return this.oq();
  };
  protoOf(AbstractDecoder).er = function (descriptor, index) {
    return this.qq(descriptor.ep(index));
  };
  protoOf(AbstractDecoder).fr = function (descriptor, index, deserializer, previousValue) {
    return this.rq(deserializer, previousValue);
  };
  protoOf(AbstractDecoder).hr = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = deserializer.nn().so();
    var tmp;
    if (isNullabilitySupported || this.eq()) {
      // Inline function 'kotlinx.serialization.encoding.AbstractDecoder.decodeNullableSerializableElement.<anonymous>' call
      tmp = this.rq(deserializer, previousValue);
    } else {
      tmp = this.fq();
    }
    return tmp;
  };
  function AbstractEncoder() {
  }
  protoOf(AbstractEncoder).tq = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).uq = function (descriptor) {
  };
  protoOf(AbstractEncoder).lr = function (descriptor, index) {
    return true;
  };
  protoOf(AbstractEncoder).mr = function (value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(AbstractEncoder).nr = function () {
    throw SerializationException_init_$Create$_0("'null' is not supported by default");
  };
  protoOf(AbstractEncoder).or = function (value) {
    return this.mr(value);
  };
  protoOf(AbstractEncoder).pr = function (value) {
    return this.mr(value);
  };
  protoOf(AbstractEncoder).qr = function (value) {
    return this.mr(value);
  };
  protoOf(AbstractEncoder).rr = function (value) {
    return this.mr(value);
  };
  protoOf(AbstractEncoder).sr = function (value) {
    return this.mr(value);
  };
  protoOf(AbstractEncoder).tr = function (value) {
    return this.mr(value);
  };
  protoOf(AbstractEncoder).ur = function (value) {
    return this.mr(value);
  };
  protoOf(AbstractEncoder).vr = function (value) {
    return this.mr(new Char(value));
  };
  protoOf(AbstractEncoder).wr = function (value) {
    return this.mr(value);
  };
  protoOf(AbstractEncoder).xr = function (enumDescriptor, index) {
    return this.mr(index);
  };
  protoOf(AbstractEncoder).yr = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).zr = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.or(value);
    }
  };
  protoOf(AbstractEncoder).as = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.pr(value);
    }
  };
  protoOf(AbstractEncoder).bs = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.qr(value);
    }
  };
  protoOf(AbstractEncoder).cs = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.rr(value);
    }
  };
  protoOf(AbstractEncoder).ds = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.sr(value);
    }
  };
  protoOf(AbstractEncoder).es = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.tr(value);
    }
  };
  protoOf(AbstractEncoder).fs = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.ur(value);
    }
  };
  protoOf(AbstractEncoder).gs = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.vr(value);
    }
  };
  protoOf(AbstractEncoder).hs = function (descriptor, index, value) {
    if (this.lr(descriptor, index)) {
      this.wr(value);
    }
  };
  protoOf(AbstractEncoder).is = function (descriptor, index) {
    return this.lr(descriptor, index) ? this.yr(descriptor.ep(index)) : NoOpEncoder_getInstance();
  };
  protoOf(AbstractEncoder).js = function (descriptor, index, serializer, value) {
    if (this.lr(descriptor, index)) {
      this.ks(serializer, value);
    }
  };
  protoOf(AbstractEncoder).ls = function (descriptor, index, serializer, value) {
    if (this.lr(descriptor, index)) {
      this.ms(serializer, value);
    }
  };
  function Decoder() {
  }
  function CompositeDecoder() {
  }
  function Encoder() {
  }
  function CompositeEncoder() {
  }
  function decodeSequentially_0($this, compositeDecoder) {
    var klassName = compositeDecoder.dr($this.nn(), 0);
    var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
    return compositeDecoder.gr($this.nn(), 1, serializer);
  }
  function AbstractPolymorphicSerializer() {
  }
  protoOf(AbstractPolymorphicSerializer).do = function (encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.nn();
    var composite = encoder.tq(descriptor);
    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
    composite.hs(this.nn(), 0, actualSerializer.nn().wo());
    var tmp = this.nn();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.js(tmp, 1, tmp$ret$0, value);
    composite.uq(descriptor);
  };
  protoOf(AbstractPolymorphicSerializer).on = function (encoder, value) {
    return this.do(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(AbstractPolymorphicSerializer).pn = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.nn();
    var composite = decoder.tq(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
      var klassName = null;
      var value = null;
      if (composite.ir()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.jr(this.nn());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.dr(this.nn(), index);
            break;
          case 1:
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              var value_0 = klassName;
              // Inline function 'kotlin.contracts.contract' call
              if (value_0 == null) {
                // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException_init_$Create$(toString(message));
              } else {
                tmp$ret$2 = value_0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer_0(this, composite, klassName);
            value = composite.gr(this.nn(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        var value_1 = value;
        // Inline function 'kotlin.contracts.contract' call
        if (value_1 == null) {
          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        } else {
          tmp$ret$4 = value_1;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.uq(descriptor);
    return result;
  };
  protoOf(AbstractPolymorphicSerializer).eo = function (decoder, klassName) {
    return decoder.jo().qs(this.co(), klassName);
  };
  protoOf(AbstractPolymorphicSerializer).fo = function (encoder, value) {
    return encoder.jo().rs(this.co(), value);
  };
  function throwSubtypeNotRegistered(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass.cb();
    throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
  }
  function throwSubtypeNotRegistered_0(subClassName, baseClass) {
    var scope = "in the polymorphic scope of '" + baseClass.cb() + "'";
    throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.cb() + "' has to be sealed and '@Serializable'."));
  }
  function NothingSerializer_0() {
    NothingSerializer_instance = this;
    this.ss_1 = NothingSerialDescriptor_getInstance();
  }
  protoOf(NothingSerializer_0).nn = function () {
    return this.ss_1;
  };
  protoOf(NothingSerializer_0).ts = function (encoder, value) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
  };
  protoOf(NothingSerializer_0).on = function (encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.ts(encoder, tmp);
  };
  protoOf(NothingSerializer_0).pn = function (decoder) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
  };
  var NothingSerializer_instance;
  function NothingSerializer_getInstance() {
    if (NothingSerializer_instance == null)
      new NothingSerializer_0();
    return NothingSerializer_instance;
  }
  function DurationSerializer() {
    DurationSerializer_instance = this;
    this.us_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
  }
  protoOf(DurationSerializer).nn = function () {
    return this.us_1;
  };
  protoOf(DurationSerializer).vs = function (encoder, value) {
    encoder.wr(Duration__toIsoString_impl_9h6wsm(value));
  };
  protoOf(DurationSerializer).on = function (encoder, value) {
    return this.vs(encoder, value instanceof Duration ? value.qk_1 : THROW_CCE());
  };
  protoOf(DurationSerializer).ws = function (decoder) {
    return Companion_getInstance().pk(decoder.oq());
  };
  protoOf(DurationSerializer).pn = function (decoder) {
    return new Duration(this.ws(decoder));
  };
  var DurationSerializer_instance;
  function DurationSerializer_getInstance() {
    if (DurationSerializer_instance == null)
      new DurationSerializer();
    return DurationSerializer_instance;
  }
  function UuidSerializer() {
    UuidSerializer_instance = this;
    this.xs_1 = new PrimitiveSerialDescriptor_0('kotlin.uuid.Uuid', STRING_getInstance());
  }
  protoOf(UuidSerializer).nn = function () {
    return this.xs_1;
  };
  protoOf(UuidSerializer).ys = function (encoder, value) {
    encoder.wr(value.toString());
  };
  protoOf(UuidSerializer).on = function (encoder, value) {
    return this.ys(encoder, value instanceof Uuid ? value : THROW_CCE());
  };
  protoOf(UuidSerializer).pn = function (decoder) {
    return Companion_getInstance_0().ql(decoder.oq());
  };
  var UuidSerializer_instance;
  function UuidSerializer_getInstance() {
    if (UuidSerializer_instance == null)
      new UuidSerializer();
    return UuidSerializer_instance;
  }
  function CachedNames() {
  }
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayListClassDesc).wo = function () {
    return 'kotlin.collections.ArrayList';
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(HashSetClassDesc).wo = function () {
    return 'kotlin.collections.HashSet';
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(LinkedHashSetClassDesc).wo = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayClassDesc).wo = function () {
    return 'kotlin.Array';
  };
  function ListLikeDescriptor(elementDescriptor) {
    this.bt_1 = elementDescriptor;
    this.ct_1 = 1;
  }
  protoOf(ListLikeDescriptor).xo = function () {
    return LIST_getInstance();
  };
  protoOf(ListLikeDescriptor).zo = function () {
    return this.ct_1;
  };
  protoOf(ListLikeDescriptor).bp = function (index) {
    return index.toString();
  };
  protoOf(ListLikeDescriptor).cp = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ListLikeDescriptor).fp = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.wo() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(ListLikeDescriptor).dp = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.wo() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(ListLikeDescriptor).ep = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.wo() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.bt_1;
  };
  protoOf(ListLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.bt_1, other.bt_1) && this.wo() === other.wo())
      return true;
    return false;
  };
  protoOf(ListLikeDescriptor).hashCode = function () {
    return imul(hashCode(this.bt_1), 31) + getStringHashCode(this.wo()) | 0;
  };
  protoOf(ListLikeDescriptor).toString = function () {
    return this.wo() + '(' + toString(this.bt_1) + ')';
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this.ht_1 = serialName;
    this.it_1 = keyDescriptor;
    this.jt_1 = valueDescriptor;
    this.kt_1 = 2;
  }
  protoOf(MapLikeDescriptor).wo = function () {
    return this.ht_1;
  };
  protoOf(MapLikeDescriptor).xo = function () {
    return MAP_getInstance();
  };
  protoOf(MapLikeDescriptor).zo = function () {
    return this.kt_1;
  };
  protoOf(MapLikeDescriptor).bp = function (index) {
    return index.toString();
  };
  protoOf(MapLikeDescriptor).cp = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).fp = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.wo() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(MapLikeDescriptor).dp = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.wo() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(MapLikeDescriptor).ep = function (index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.wo() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.it_1;
        break;
      case 1:
        tmp = this.jt_1;
        break;
      default:
        var message_0 = 'Unreached';
        throw IllegalStateException_init_$Create$(toString(message_0));
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.wo() === other.wo()))
      return false;
    if (!equals(this.it_1, other.it_1))
      return false;
    if (!equals(this.jt_1, other.jt_1))
      return false;
    return true;
  };
  protoOf(MapLikeDescriptor).hashCode = function () {
    var result = getStringHashCode(this.wo());
    result = imul(31, result) + hashCode(this.it_1) | 0;
    result = imul(31, result) + hashCode(this.jt_1) | 0;
    return result;
  };
  protoOf(MapLikeDescriptor).toString = function () {
    return this.wo() + '(' + toString(this.it_1) + ', ' + toString(this.jt_1) + ')';
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this.pt_1 = primitive.wo() + 'Array';
  }
  protoOf(PrimitiveArrayDescriptor).wo = function () {
    return this.pt_1;
  };
  function ArrayListSerializer(element) {
    CollectionSerializer.call(this, element);
    this.rt_1 = new ArrayListClassDesc(element.nn());
  }
  protoOf(ArrayListSerializer).nn = function () {
    return this.rt_1;
  };
  protoOf(ArrayListSerializer).st = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ArrayListSerializer).tt = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(ArrayListSerializer).ut = function (_this__u8e3s4) {
    return this.tt(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).vt = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(ArrayListSerializer).wt = function (_this__u8e3s4) {
    return this.vt(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).xt = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(ArrayListSerializer).yt = function (_this__u8e3s4) {
    return this.xt((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).zt = function (_this__u8e3s4, size) {
    return _this__u8e3s4.o5(size);
  };
  protoOf(ArrayListSerializer).au = function (_this__u8e3s4, size) {
    return this.zt(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ArrayListSerializer).bu = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.i2(index, element);
  };
  protoOf(ArrayListSerializer).cu = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.bu(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.nu_1 = new HashSetClassDesc(eSerializer.nn());
  }
  protoOf(HashSetSerializer).nn = function () {
    return this.nu_1;
  };
  protoOf(HashSetSerializer).st = function () {
    return HashSet_init_$Create$();
  };
  protoOf(HashSetSerializer).ou = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(HashSetSerializer).ut = function (_this__u8e3s4) {
    return this.ou(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).pu = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashSetSerializer).wt = function (_this__u8e3s4) {
    return this.pu(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).qu = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashSetSerializer).yt = function (_this__u8e3s4) {
    return this.qu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).ru = function (_this__u8e3s4, size) {
  };
  protoOf(HashSetSerializer).au = function (_this__u8e3s4, size) {
    return this.ru(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(HashSetSerializer).su = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.e(element);
  };
  protoOf(HashSetSerializer).cu = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE();
    return this.su(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function LinkedHashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.uu_1 = new LinkedHashSetClassDesc(eSerializer.nn());
  }
  protoOf(LinkedHashSetSerializer).nn = function () {
    return this.uu_1;
  };
  protoOf(LinkedHashSetSerializer).st = function () {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet_init_$Create$();
  };
  protoOf(LinkedHashSetSerializer).vu = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(LinkedHashSetSerializer).ut = function (_this__u8e3s4) {
    return this.vu(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).wu = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashSetSerializer).wt = function (_this__u8e3s4) {
    return this.wu(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).qu = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashSetSerializer).yt = function (_this__u8e3s4) {
    return this.qu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).xu = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashSetSerializer).au = function (_this__u8e3s4, size) {
    return this.xu(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(LinkedHashSetSerializer).yu = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.e(element);
  };
  protoOf(LinkedHashSetSerializer).cu = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.yu(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.bv_1 = new HashMapClassDesc(kSerializer.nn(), vSerializer.nn());
  }
  protoOf(HashMapSerializer).nn = function () {
    return this.bv_1;
  };
  protoOf(HashMapSerializer).cv = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(HashMapSerializer).dv = function (_this__u8e3s4) {
    return this.cv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).ev = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.u().g();
  };
  protoOf(HashMapSerializer).fv = function (_this__u8e3s4) {
    return this.ev((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).st = function () {
    return HashMap_init_$Create$();
  };
  protoOf(HashMapSerializer).gv = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.j(), 2);
  };
  protoOf(HashMapSerializer).ut = function (_this__u8e3s4) {
    return this.gv(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).hv = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashMapSerializer).wt = function (_this__u8e3s4) {
    return this.hv(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).iv = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashMapSerializer).yt = function (_this__u8e3s4) {
    return this.iv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).jv = function (_this__u8e3s4, size) {
  };
  protoOf(HashMapSerializer).au = function (_this__u8e3s4, size) {
    return this.jv(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.qv_1 = new LinkedHashMapClassDesc(kSerializer.nn(), vSerializer.nn());
  }
  protoOf(LinkedHashMapSerializer).nn = function () {
    return this.qv_1;
  };
  protoOf(LinkedHashMapSerializer).cv = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(LinkedHashMapSerializer).dv = function (_this__u8e3s4) {
    return this.cv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).ev = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.u().g();
  };
  protoOf(LinkedHashMapSerializer).fv = function (_this__u8e3s4) {
    return this.ev((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).st = function () {
    return LinkedHashMap_init_$Create$();
  };
  protoOf(LinkedHashMapSerializer).rv = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.j(), 2);
  };
  protoOf(LinkedHashMapSerializer).ut = function (_this__u8e3s4) {
    return this.rv(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).sv = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashMapSerializer).wt = function (_this__u8e3s4) {
    return this.sv(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).iv = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashMapSerializer).yt = function (_this__u8e3s4) {
    return this.iv((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).tv = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashMapSerializer).au = function (_this__u8e3s4, size) {
    return this.tv(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    CollectionLikeSerializer.call(this, eSerializer);
    this.vv_1 = kClass;
    this.wv_1 = new ArrayClassDesc(eSerializer.nn());
  }
  protoOf(ReferenceArraySerializer).nn = function () {
    return this.wv_1;
  };
  protoOf(ReferenceArraySerializer).xv = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ReferenceArraySerializer).dv = function (_this__u8e3s4) {
    return this.xv((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).yv = function (_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  };
  protoOf(ReferenceArraySerializer).fv = function (_this__u8e3s4) {
    return this.yv((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).st = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ReferenceArraySerializer).zv = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(ReferenceArraySerializer).ut = function (_this__u8e3s4) {
    return this.zv(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).aw = function (_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.vv_1);
  };
  protoOf(ReferenceArraySerializer).wt = function (_this__u8e3s4) {
    return this.aw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).bw = function (_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
  };
  protoOf(ReferenceArraySerializer).yt = function (_this__u8e3s4) {
    return this.bw((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).cw = function (_this__u8e3s4, size) {
    return _this__u8e3s4.o5(size);
  };
  protoOf(ReferenceArraySerializer).au = function (_this__u8e3s4, size) {
    return this.cw(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ReferenceArraySerializer).dw = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.i2(index, element);
  };
  protoOf(ReferenceArraySerializer).cu = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.dw(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  function CollectionSerializer(element) {
    CollectionLikeSerializer.call(this, element);
  }
  protoOf(CollectionSerializer).eu = function (_this__u8e3s4) {
    return _this__u8e3s4.j();
  };
  protoOf(CollectionSerializer).dv = function (_this__u8e3s4) {
    return this.eu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CollectionSerializer).fu = function (_this__u8e3s4) {
    return _this__u8e3s4.g();
  };
  protoOf(CollectionSerializer).fv = function (_this__u8e3s4) {
    return this.fu((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this.kv_1 = keySerializer;
    this.lv_1 = valueSerializer;
  }
  protoOf(MapLikeSerializer).mv = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.y_1;
    var last = progression.z_1;
    var step_0 = progression.a1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.nv(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  };
  protoOf(MapLikeSerializer).iu = function (decoder, builder, startIndex, size) {
    return this.mv(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  };
  protoOf(MapLikeSerializer).nv = function (decoder, index, builder, checkIndex) {
    var key = decoder.gr(this.nn(), index, this.kv_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.jr(this.nn());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>' call
      // Inline function 'kotlin.require' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(this_0 === (index + 1 | 0))) {
        // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.readElement.<anonymous>.<anonymous>' call
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.z1(key)) {
      var tmp_2 = this.lv_1.nn().xo();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.fr(this.nn(), vIndex, this.lv_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.gr(this.nn(), vIndex, this.lv_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.k2(key, value);
  };
  protoOf(MapLikeSerializer).ju = function (decoder, index, builder, checkIndex) {
    return this.nv(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(MapLikeSerializer).hu = function (encoder, value) {
    var size = this.dv(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.nn();
    var composite = encoder.os(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>' call
    var iterator = this.fv(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = iterator;
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.internal.MapLikeSerializer.serialize.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var k = element.v();
      // Inline function 'kotlin.collections.component2' call
      var v = element.w();
      var tmp = this.nn();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      composite.js(tmp, _unary__edvuaz, this.kv_1, k);
      var tmp_0 = this.nn();
      var _unary__edvuaz_0 = index;
      index = _unary__edvuaz_0 + 1 | 0;
      composite.js(tmp_0, _unary__edvuaz_0, this.lv_1, v);
    }
    composite.uq(descriptor);
  };
  protoOf(MapLikeSerializer).on = function (encoder, value) {
    return this.hu(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  function CollectionLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this.gu_1 = elementSerializer;
  }
  protoOf(CollectionLikeSerializer).hu = function (encoder, value) {
    var size = this.dv(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.nn();
    var composite = encoder.os(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
    var iterator = this.fv(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.js(this.nn(), index, this.gu_1, iterator.i());
      }
       while (inductionVariable < size);
    composite.uq(descriptor);
  };
  protoOf(CollectionLikeSerializer).on = function (encoder, value) {
    return this.hu(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(CollectionLikeSerializer).iu = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ju(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  };
  protoOf(CollectionLikeSerializer).ju = function (decoder, index, builder, checkIndex) {
    this.cu(builder, index, decoder.gr(this.nn(), index, this.gu_1));
  };
  function readSize($this, decoder, builder) {
    var size = decoder.kr($this.nn());
    $this.au(builder, size);
    return size;
  }
  function AbstractCollectionSerializer() {
  }
  protoOf(AbstractCollectionSerializer).lu = function (decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.yt(previous);
    var builder = tmp1_elvis_lhs == null ? this.st() : tmp1_elvis_lhs;
    var startIndex = this.ut(builder);
    var compositeDecoder = decoder.tq(this.nn());
    if (compositeDecoder.ir()) {
      this.iu(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.jr(this.nn());
        if (index === -1)
          break $l$loop;
        this.ku(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.uq(this.nn());
    return this.wt(builder);
  };
  protoOf(AbstractCollectionSerializer).pn = function (decoder) {
    return this.lu(decoder, null);
  };
  protoOf(AbstractCollectionSerializer).ku = function (decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.ju(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.ju.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    CollectionLikeSerializer.call(this, primitiveSerializer);
    this.fw_1 = new PrimitiveArrayDescriptor(primitiveSerializer.nn());
  }
  protoOf(PrimitiveArraySerializer).nn = function () {
    return this.fw_1;
  };
  protoOf(PrimitiveArraySerializer).gw = function (_this__u8e3s4) {
    return _this__u8e3s4.hw();
  };
  protoOf(PrimitiveArraySerializer).ut = function (_this__u8e3s4) {
    return this.gw(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).iw = function (_this__u8e3s4) {
    return _this__u8e3s4.jw();
  };
  protoOf(PrimitiveArraySerializer).wt = function (_this__u8e3s4) {
    return this.iw(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).kw = function (_this__u8e3s4, size) {
    return _this__u8e3s4.lw(size);
  };
  protoOf(PrimitiveArraySerializer).au = function (_this__u8e3s4, size) {
    return this.kw(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(PrimitiveArraySerializer).mw = function (_this__u8e3s4) {
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).fv = function (_this__u8e3s4) {
    return this.mw((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).nw = function (_this__u8e3s4, index, element) {
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).cu = function (_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
    return this.nw(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).st = function () {
    return this.yt(this.ow());
  };
  protoOf(PrimitiveArraySerializer).rw = function (encoder, value) {
    var size = this.dv(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.fw_1;
    var composite = encoder.os(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
    this.qw(composite, value, size);
    composite.uq(descriptor);
  };
  protoOf(PrimitiveArraySerializer).on = function (encoder, value) {
    return this.rw(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).hu = function (encoder, value) {
    return this.rw(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).pn = function (decoder) {
    return this.lu(decoder, null);
  };
  function PrimitiveArrayBuilder() {
  }
  protoOf(PrimitiveArrayBuilder).sw = function (requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.hw() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.lw(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.lw.call(this, requiredCapacity);
    }
    return tmp;
  };
  function Companion() {
    Companion_instance_0 = this;
    this.tw_1 = longArray(0);
  }
  var Companion_instance_0;
  function Companion_getInstance_7() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function prepareHighMarksArray($this, elementsCount) {
    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
    var elementsInLastSlot = elementsCount & 63;
    var highMarks = longArray(slotsCount);
    if (!(elementsInLastSlot === 0)) {
      highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).d3(elementsCount);
    }
    return highMarks;
  }
  function markHigh($this, index) {
    var slot = (index >>> 6 | 0) - 1 | 0;
    var offsetInSlot = index & 63;
    $this.xw_1[slot] = $this.xw_1[slot].h3((new Long(1, 0)).d3(offsetInSlot));
  }
  function nextUnmarkedHighIndex($this) {
    var inductionVariable = 0;
    var last = $this.xw_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var slot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var slotOffset = imul(slot + 1 | 0, 64);
        var slotMarks = $this.xw_1[slot];
        while (!slotMarks.equals(new Long(-1, -1))) {
          var indexInSlot = countTrailingZeroBits(slotMarks.c3());
          slotMarks = slotMarks.h3((new Long(1, 0)).d3(indexInSlot));
          var index = slotOffset + indexInSlot | 0;
          if ($this.vw_1($this.uw_1, index)) {
            $this.xw_1[slot] = slotMarks;
            return index;
          }
        }
        $this.xw_1[slot] = slotMarks;
      }
       while (inductionVariable <= last);
    return -1;
  }
  function ElementMarker(descriptor, readIfAbsent) {
    Companion_getInstance_7();
    this.uw_1 = descriptor;
    this.vw_1 = readIfAbsent;
    var elementsCount = this.uw_1.zo();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = (new Long(-1, -1)).d3(elementsCount);
      }
      tmp.ww_1 = tmp_0;
      this.xw_1 = Companion_getInstance_7().tw_1;
    } else {
      this.ww_1 = new Long(0, 0);
      this.xw_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  protoOf(ElementMarker).yw = function (index) {
    if (index < 64) {
      this.ww_1 = this.ww_1.h3((new Long(1, 0)).d3(index));
    } else {
      markHigh(this, index);
    }
  };
  protoOf(ElementMarker).zw = function () {
    var elementsCount = this.uw_1.zo();
    while (!this.ww_1.equals(new Long(-1, -1))) {
      var index = countTrailingZeroBits(this.ww_1.c3());
      this.ww_1 = this.ww_1.h3((new Long(1, 0)).d3(index));
      if (this.vw_1(this.uw_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  };
  function createSimpleEnumSerializer(serialName, values) {
    return new EnumSerializer(serialName, values);
  }
  function createUnmarkedDescriptor($this, serialName) {
    var d = new EnumDescriptor(serialName, $this.ax_1.length);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.ax_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlinx.serialization.internal.EnumSerializer.createUnmarkedDescriptor.<anonymous>' call
      d.px(element.n2_1);
    }
    return d;
  }
  function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
    return function () {
      var tmp0_elvis_lhs = this$0.bx_1;
      return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
    };
  }
  function EnumSerializer(serialName, values) {
    this.ax_1 = values;
    this.bx_1 = null;
    var tmp = this;
    tmp.cx_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
  }
  protoOf(EnumSerializer).nn = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.cx_1;
    descriptor$factory_1();
    return this_0.w();
  };
  protoOf(EnumSerializer).qx = function (encoder, value) {
    var index = indexOf(this.ax_1, value);
    if (index === -1) {
      throw SerializationException_init_$Create$_0(toString(value) + ' is not a valid enum ' + this.nn().wo() + ', ' + ('must be one of ' + contentToString(this.ax_1)));
    }
    encoder.xr(this.nn(), index);
  };
  protoOf(EnumSerializer).on = function (encoder, value) {
    return this.qx(encoder, value instanceof Enum ? value : THROW_CCE());
  };
  protoOf(EnumSerializer).pn = function (decoder) {
    var index = decoder.pq(this.nn());
    if (!(0 <= index ? index <= (this.ax_1.length - 1 | 0) : false)) {
      throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.nn().wo() + ' enum values, ' + ('values size is ' + this.ax_1.length));
    }
    return this.ax_1[index];
  };
  protoOf(EnumSerializer).toString = function () {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.nn().wo() + '>';
  };
  function _get_elementDescriptors__y23q9p($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.ey_1;
    elementDescriptors$factory();
    return this_0.w();
  }
  function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
    return function () {
      var tmp = 0;
      var tmp_0 = $elementsCount;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(tmp_0), null);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.bp(tmp_2), OBJECT_getInstance(), []);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function EnumDescriptor(name, elementsCount) {
    PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
    this.dy_1 = ENUM_getInstance();
    var tmp = this;
    tmp.ey_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  protoOf(EnumDescriptor).xo = function () {
    return this.dy_1;
  };
  protoOf(EnumDescriptor).ep = function (index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  };
  protoOf(EnumDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!(!(other == null) ? isInterface(other, SerialDescriptor) : false))
      return false;
    if (!(other.xo() === ENUM_getInstance()))
      return false;
    if (!(this.wo() === other.wo()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  };
  protoOf(EnumDescriptor).toString = function () {
    return joinToString(get_elementNames(this), ', ', this.wo() + '(', ')');
  };
  protoOf(EnumDescriptor).hashCode = function () {
    var result = getStringHashCode(this.wo());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = get_elementNames(this).g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.EnumDescriptor.hashCode.<anonymous>' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  };
  function descriptor$factory_1() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.nn();
    }, null);
  }
  function elementDescriptors$factory() {
    return getPropertyCallableRef('elementDescriptors', 1, KProperty1, function (receiver) {
      return _get_elementDescriptors__y23q9p(receiver);
    }, null);
  }
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
  }
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this.ty_1 = true;
  }
  protoOf(InlineClassDescriptor).yo = function () {
    return this.ty_1;
  };
  protoOf(InlineClassDescriptor).hashCode = function () {
    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
  };
  protoOf(InlineClassDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.wo() === other.wo())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.InlineClassDescriptor.equals.<anonymous>' call
      if (!(other.ty_1 && contentEquals(this.fy(), other.fy()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.zo() === other.zo())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.zo();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.ep(index).wo() === other.ep(index).wo())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.ep(index).xo(), other.ep(index).xo())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
    this.uy_1 = $primitiveSerializer;
  }
  protoOf(InlinePrimitiveDescriptor$1).vy = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.uy_1];
  };
  protoOf(InlinePrimitiveDescriptor$1).nn = function () {
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).on = function (encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).pn = function (decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  function jsonCachedSerialNames(_this__u8e3s4) {
    return cachedSerialNames(_this__u8e3s4);
  }
  function NoOpEncoder() {
    NoOpEncoder_instance = this;
    AbstractEncoder.call(this);
    this.xy_1 = EmptySerializersModule_0();
  }
  protoOf(NoOpEncoder).jo = function () {
    return this.xy_1;
  };
  protoOf(NoOpEncoder).mr = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).nr = function () {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).or = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).pr = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).qr = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).rr = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).sr = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).tr = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).ur = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).vr = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).wr = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).xr = function (enumDescriptor, index) {
    return Unit_instance;
  };
  var NoOpEncoder_instance;
  function NoOpEncoder_getInstance() {
    if (NoOpEncoder_instance == null)
      new NoOpEncoder();
    return NoOpEncoder_instance;
  }
  function error($this) {
    throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
  }
  function NothingSerialDescriptor() {
    NothingSerialDescriptor_instance = this;
    this.yy_1 = OBJECT_getInstance();
    this.zy_1 = 'kotlin.Nothing';
  }
  protoOf(NothingSerialDescriptor).xo = function () {
    return this.yy_1;
  };
  protoOf(NothingSerialDescriptor).wo = function () {
    return this.zy_1;
  };
  protoOf(NothingSerialDescriptor).zo = function () {
    return 0;
  };
  protoOf(NothingSerialDescriptor).bp = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).cp = function (name) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).fp = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).ep = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).dp = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).toString = function () {
    return 'NothingSerialDescriptor';
  };
  protoOf(NothingSerialDescriptor).equals = function (other) {
    return this === other;
  };
  protoOf(NothingSerialDescriptor).hashCode = function () {
    return getStringHashCode(this.zy_1) + imul(31, this.yy_1.hashCode()) | 0;
  };
  var NothingSerialDescriptor_instance;
  function NothingSerialDescriptor_getInstance() {
    if (NothingSerialDescriptor_instance == null)
      new NothingSerialDescriptor();
    return NothingSerialDescriptor_instance;
  }
  function NullableSerializer(serializer) {
    this.az_1 = serializer;
    this.bz_1 = new SerialDescriptorForNullable(this.az_1.nn());
  }
  protoOf(NullableSerializer).nn = function () {
    return this.bz_1;
  };
  protoOf(NullableSerializer).cz = function (encoder, value) {
    if (!(value == null)) {
      encoder.ns();
      encoder.ks(this.az_1, value);
    } else {
      encoder.nr();
    }
  };
  protoOf(NullableSerializer).on = function (encoder, value) {
    return this.cz(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(NullableSerializer).pn = function (decoder) {
    return decoder.eq() ? decoder.sq(this.az_1) : decoder.fq();
  };
  protoOf(NullableSerializer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.az_1, other.az_1))
      return false;
    return true;
  };
  protoOf(NullableSerializer).hashCode = function () {
    return hashCode(this.az_1);
  };
  function SerialDescriptorForNullable(original) {
    this.gp_1 = original;
    this.hp_1 = this.gp_1.wo() + '?';
    this.ip_1 = cachedSerialNames(this.gp_1);
  }
  protoOf(SerialDescriptorForNullable).wo = function () {
    return this.hp_1;
  };
  protoOf(SerialDescriptorForNullable).cq = function () {
    return this.ip_1;
  };
  protoOf(SerialDescriptorForNullable).so = function () {
    return true;
  };
  protoOf(SerialDescriptorForNullable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.gp_1, other.gp_1))
      return false;
    return true;
  };
  protoOf(SerialDescriptorForNullable).toString = function () {
    return toString(this.gp_1) + '?';
  };
  protoOf(SerialDescriptorForNullable).hashCode = function () {
    return imul(hashCode(this.gp_1), 31);
  };
  protoOf(SerialDescriptorForNullable).xo = function () {
    return this.gp_1.xo();
  };
  protoOf(SerialDescriptorForNullable).yo = function () {
    return this.gp_1.yo();
  };
  protoOf(SerialDescriptorForNullable).zo = function () {
    return this.gp_1.zo();
  };
  protoOf(SerialDescriptorForNullable).ap = function () {
    return this.gp_1.ap();
  };
  protoOf(SerialDescriptorForNullable).bp = function (index) {
    return this.gp_1.bp(index);
  };
  protoOf(SerialDescriptorForNullable).cp = function (name) {
    return this.gp_1.cp(name);
  };
  protoOf(SerialDescriptorForNullable).dp = function (index) {
    return this.gp_1.dp(index);
  };
  protoOf(SerialDescriptorForNullable).ep = function (index) {
    return this.gp_1.ep(index);
  };
  protoOf(SerialDescriptorForNullable).fp = function (index) {
    return this.gp_1.fp(index);
  };
  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.sn_1 = this$0.ez_1;
      return Unit_instance;
    };
  }
  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = OBJECT_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function ObjectSerializer(serialName, objectInstance) {
    this.dz_1 = objectInstance;
    this.ez_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.fz_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  protoOf(ObjectSerializer).nn = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.fz_1;
    descriptor$factory_2();
    return this_0.w();
  };
  protoOf(ObjectSerializer).do = function (encoder, value) {
    encoder.tq(this.nn()).uq(this.nn());
  };
  protoOf(ObjectSerializer).on = function (encoder, value) {
    return this.do(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ObjectSerializer).pn = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.nn();
    var composite = decoder.tq(descriptor);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlinx.serialization.internal.ObjectSerializer.deserialize.<anonymous>' call
      if (composite.ir()) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.jr(this.nn());
      if (index === -1) {
        tmp$ret$0 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
    var result = tmp$ret$0;
    composite.uq(descriptor);
    return this.dz_1;
  };
  function descriptor$factory_2() {
    return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
      return receiver.nn();
    }, null);
  }
  function get_EMPTY_DESCRIPTOR_ARRAY() {
    _init_properties_Platform_common_kt__3qzecs();
    return EMPTY_DESCRIPTOR_ARRAY;
  }
  var EMPTY_DESCRIPTOR_ARRAY;
  function cachedSerialNames(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    if (isInterface(_this__u8e3s4, CachedNames))
      return _this__u8e3s4.cq();
    var result = HashSet_init_$Create$_1(_this__u8e3s4.zo());
    var inductionVariable = 0;
    var last = _this__u8e3s4.zo();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = _this__u8e3s4.bp(i);
        result.e(element);
      }
       while (inductionVariable < last);
    return result;
  }
  function kclass(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var t = _this__u8e3s4.rb();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
        throw IllegalArgumentException_init_$Create$('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
      } else {
        throw IllegalArgumentException_init_$Create$('Only KClass supported as classifier, got ' + toString_0(t));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function typeOrThrow(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      var value = _this__u8e3s4.dj_1;
      // Inline function 'kotlin.contracts.contract' call
      if (value == null) {
        // Inline function 'kotlinx.serialization.internal.typeOrThrow.<anonymous>' call
        var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.dj_1);
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$1 = value;
        break $l$block;
      }
    }
    return tmp$ret$1;
  }
  function notRegisteredMessage(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0_elvis_lhs = _this__u8e3s4.cb();
    return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
  }
  function compactArray(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    // Inline function 'kotlin.takeUnless' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(_this__u8e3s4 == null || _this__u8e3s4.k())) {
      tmp = _this__u8e3s4;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
  }
  function notRegisteredMessage_0(className) {
    _init_properties_Platform_common_kt__3qzecs();
    return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
  }
  function serializerNotRegistered(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
  }
  var properties_initialized_Platform_common_kt_i7q4ty;
  function _init_properties_Platform_common_kt__3qzecs() {
    if (!properties_initialized_Platform_common_kt_i7q4ty) {
      properties_initialized_Platform_common_kt_i7q4ty = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_DESCRIPTOR_ARRAY = [];
    }
  }
  function throwMissingFieldException(seen, goldenMask, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$_0();
    var missingFieldsBits = goldenMask & ~seen;
    var inductionVariable = 0;
    if (inductionVariable < 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((missingFieldsBits & 1) === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element = descriptor.bp(i);
          missingFields.e(element);
        }
        missingFieldsBits = missingFieldsBits >>> 1 | 0;
      }
       while (inductionVariable < 32);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.wo());
  }
  function hashCodeImpl(_this__u8e3s4, typeParams) {
    var result = getStringHashCode(_this__u8e3s4.wo());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var tmp0_iterator = elementDescriptors.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      var tmp0_safe_receiver = element.wo();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var namesHash = accumulator;
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = 1;
    var tmp0_iterator_0 = elementDescriptors.g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
      var hash_0 = accumulator_0;
      var tmp_0 = imul(31, hash_0);
      // Inline function 'kotlin.hashCode' call
      // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
      var tmp0_safe_receiver_0 = element_0.xo();
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    }
    var kindHash = accumulator_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function _get_childSerializers__7vnyfa($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.mx_1;
    childSerializers$factory();
    return this_0.w();
  }
  function _get__hashCode__tgwhef_0($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.ox_1;
    _hashCode$factory_0();
    return this_0.w();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = $this.hx_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = $this.hx_1[i];
        indices.k2(key, i);
      }
       while (inductionVariable <= last);
    return indices;
  }
  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.ex_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vy();
      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
    };
  }
  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.ex_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wy();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
          var tmp$ret$0 = item.nn();
          destination.e(tmp$ret$0);
        }
        tmp = destination;
      }
      return compactArray(tmp);
    };
  }
  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.fy());
    };
  }
  function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
    return function (i) {
      return this$0.bp(i) + ': ' + this$0.ep(i).wo();
    };
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.dx_1 = serialName;
    this.ex_1 = generatedSerializer;
    this.fx_1 = elementsCount;
    this.gx_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.fx_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.hx_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.fx_1;
    tmp_3.ix_1 = fillArrayVal(Array(size), null);
    this.jx_1 = null;
    this.kx_1 = booleanArray(this.fx_1);
    this.lx_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.mx_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.nx_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.ox_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  protoOf(PluginGeneratedSerialDescriptor).wo = function () {
    return this.dx_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).zo = function () {
    return this.fx_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).xo = function () {
    return CLASS_getInstance();
  };
  protoOf(PluginGeneratedSerialDescriptor).ap = function () {
    var tmp0_elvis_lhs = this.jx_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).cq = function () {
    return this.lx_1.c2();
  };
  protoOf(PluginGeneratedSerialDescriptor).fy = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.nx_1;
    typeParameterDescriptors$factory();
    return this_0.w();
  };
  protoOf(PluginGeneratedSerialDescriptor).gy = function (name, isOptional) {
    this.gx_1 = this.gx_1 + 1 | 0;
    this.hx_1[this.gx_1] = name;
    this.kx_1[this.gx_1] = isOptional;
    this.ix_1[this.gx_1] = null;
    if (this.gx_1 === (this.fx_1 - 1 | 0)) {
      this.lx_1 = buildIndices(this);
    }
  };
  protoOf(PluginGeneratedSerialDescriptor).px = function (name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.gy(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.gy.call(this, name, isOptional);
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).ep = function (index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).nn();
  };
  protoOf(PluginGeneratedSerialDescriptor).fp = function (index) {
    return getChecked_0(this.kx_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).dp = function (index) {
    var tmp0_elvis_lhs = getChecked(this.ix_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).bp = function (index) {
    return getChecked(this.hx_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).cp = function (name) {
    var tmp0_elvis_lhs = this.lx_1.b2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.wo() === other.wo())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
      if (!contentEquals(this.fy(), other.fy())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.zo() === other.zo())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.zo();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.ep(index).wo() === other.ep(index).wo())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.ep(index).xo(), other.ep(index).xo())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
    return _get__hashCode__tgwhef_0(this);
  };
  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
    var tmp = until(0, this.fx_1);
    var tmp_0 = this.wo() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  };
  function childSerializers$factory() {
    return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
      return _get_childSerializers__7vnyfa(receiver);
    }, null);
  }
  function typeParameterDescriptors$factory() {
    return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
      return receiver.fy();
    }, null);
  }
  function _hashCode$factory_0() {
    return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
      return _get__hashCode__tgwhef_0(receiver);
    }, null);
  }
  function get_EMPTY_SERIALIZER_ARRAY() {
    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
    return EMPTY_SERIALIZER_ARRAY;
  }
  var EMPTY_SERIALIZER_ARRAY;
  function SerializerFactory() {
  }
  function GeneratedSerializer() {
  }
  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_SERIALIZER_ARRAY = [];
    }
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_2(Companion_getInstance_1()));
  }
  protoOf(CharArraySerializer_0).jz = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(CharArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.jz((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).kz = function (_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  };
  protoOf(CharArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.kz((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).ow = function () {
    return charArray(0);
  };
  protoOf(CharArraySerializer_0).lz = function (decoder, index, builder, checkIndex) {
    builder.oz(decoder.cr(this.fw_1, index));
  };
  protoOf(CharArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.lz(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.lz(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).pz = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.gs(this.fw_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(CharArraySerializer_0).qw = function (encoder, content, size) {
    return this.pz(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_3(DoubleCompanionObject_instance));
  }
  protoOf(DoubleArraySerializer_0).sz = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(DoubleArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.sz((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).tz = function (_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  };
  protoOf(DoubleArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.tz((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).ow = function () {
    return new Float64Array(0);
  };
  protoOf(DoubleArraySerializer_0).uz = function (decoder, index, builder, checkIndex) {
    builder.xz(decoder.br(this.fw_1, index));
  };
  protoOf(DoubleArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.uz(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.uz(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).yz = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.fs(this.fw_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(DoubleArraySerializer_0).qw = function (encoder, content, size) {
    return this.yz(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(FloatCompanionObject_instance));
  }
  protoOf(FloatArraySerializer_0).b10 = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(FloatArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.b10((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).c10 = function (_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  };
  protoOf(FloatArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.c10((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).ow = function () {
    return new Float32Array(0);
  };
  protoOf(FloatArraySerializer_0).d10 = function (decoder, index, builder, checkIndex) {
    builder.g10(decoder.ar(this.fw_1, index));
  };
  protoOf(FloatArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.d10(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.d10(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).h10 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.es(this.fw_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(FloatArraySerializer_0).qw = function (encoder, content, size) {
    return this.h10(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_2()));
  }
  protoOf(LongArraySerializer_0).k10 = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(LongArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.k10((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).l10 = function (_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  };
  protoOf(LongArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.l10((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).ow = function () {
    return longArray(0);
  };
  protoOf(LongArraySerializer_0).m10 = function (decoder, index, builder, checkIndex) {
    builder.p10(decoder.zq(this.fw_1, index));
  };
  protoOf(LongArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.m10(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.m10(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).q10 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.ds(this.fw_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(LongArraySerializer_0).qw = function (encoder, content, size) {
    return this.q10(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function ULongArraySerializer_0() {
    ULongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_3()));
  }
  protoOf(ULongArraySerializer_0).t10 = function (_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.t10(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.ym_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).u10 = function (_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.u10(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.ym_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).v10 = function () {
    return _ULongArray___init__impl__twm1l3(0);
  };
  protoOf(ULongArraySerializer_0).ow = function () {
    return new ULongArray(this.v10());
  };
  protoOf(ULongArraySerializer_0).w10 = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.er(this.fw_1, index).kq();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.z10(tmp$ret$0);
  };
  protoOf(ULongArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.w10(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.w10(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).a11 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.is(this.fw_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.sr(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(ULongArraySerializer_0).qw = function (encoder, content, size) {
    return this.a11(encoder, content instanceof ULongArray ? content.ym_1 : THROW_CCE(), size);
  };
  var ULongArraySerializer_instance;
  function ULongArraySerializer_getInstance() {
    if (ULongArraySerializer_instance == null)
      new ULongArraySerializer_0();
    return ULongArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(IntCompanionObject_instance));
  }
  protoOf(IntArraySerializer_0).d11 = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(IntArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.d11((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).e11 = function (_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  };
  protoOf(IntArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.e11((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).ow = function () {
    return new Int32Array(0);
  };
  protoOf(IntArraySerializer_0).f11 = function (decoder, index, builder, checkIndex) {
    builder.i11(decoder.yq(this.fw_1, index));
  };
  protoOf(IntArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.f11(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.f11(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).j11 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.cs(this.fw_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(IntArraySerializer_0).qw = function (encoder, content, size) {
    return this.j11(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function UIntArraySerializer_0() {
    UIntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(Companion_getInstance_4()));
  }
  protoOf(UIntArraySerializer_0).m11 = function (_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.m11(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.mm_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).n11 = function (_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.n11(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.mm_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).o11 = function () {
    return _UIntArray___init__impl__ghjpc6(0);
  };
  protoOf(UIntArraySerializer_0).ow = function () {
    return new UIntArray(this.o11());
  };
  protoOf(UIntArraySerializer_0).p11 = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.er(this.fw_1, index).jq();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.s11(tmp$ret$0);
  };
  protoOf(UIntArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.p11(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.p11(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).t11 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.is(this.fw_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.rr(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UIntArraySerializer_0).qw = function (encoder, content, size) {
    return this.t11(encoder, content instanceof UIntArray ? content.mm_1 : THROW_CCE(), size);
  };
  var UIntArraySerializer_instance;
  function UIntArraySerializer_getInstance() {
    if (UIntArraySerializer_instance == null)
      new UIntArraySerializer_0();
    return UIntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(ShortCompanionObject_instance));
  }
  protoOf(ShortArraySerializer_0).w11 = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ShortArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.w11((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).x11 = function (_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(ShortArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.x11((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).ow = function () {
    return new Int16Array(0);
  };
  protoOf(ShortArraySerializer_0).y11 = function (decoder, index, builder, checkIndex) {
    builder.b12(decoder.xq(this.fw_1, index));
  };
  protoOf(ShortArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.y11(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.y11(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).c12 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.bs(this.fw_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ShortArraySerializer_0).qw = function (encoder, content, size) {
    return this.c12(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function UShortArraySerializer_0() {
    UShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(Companion_getInstance_5()));
  }
  protoOf(UShortArraySerializer_0).f12 = function (_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.f12(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.kn_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).g12 = function (_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.g12(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.kn_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).h12 = function () {
    return _UShortArray___init__impl__9b26ef(0);
  };
  protoOf(UShortArraySerializer_0).ow = function () {
    return new UShortArray(this.h12());
  };
  protoOf(UShortArraySerializer_0).i12 = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.er(this.fw_1, index).iq();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.l12(tmp$ret$0);
  };
  protoOf(UShortArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.i12(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.i12(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).m12 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.is(this.fw_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.qr(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UShortArraySerializer_0).qw = function (encoder, content, size) {
    return this.m12(encoder, content instanceof UShortArray ? content.kn_1 : THROW_CCE(), size);
  };
  var UShortArraySerializer_instance;
  function UShortArraySerializer_getInstance() {
    if (UShortArraySerializer_instance == null)
      new UShortArraySerializer_0();
    return UShortArraySerializer_instance;
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_11(ByteCompanionObject_instance));
  }
  protoOf(ByteArraySerializer_0).p12 = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ByteArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.p12((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).q12 = function (_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(ByteArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.q12((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).ow = function () {
    return new Int8Array(0);
  };
  protoOf(ByteArraySerializer_0).r12 = function (decoder, index, builder, checkIndex) {
    builder.u12(decoder.wq(this.fw_1, index));
  };
  protoOf(ByteArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.r12(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.r12(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).v12 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.as(this.fw_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ByteArraySerializer_0).qw = function (encoder, content, size) {
    return this.v12(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function UByteArraySerializer_0() {
    UByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_12(Companion_getInstance_6()));
  }
  protoOf(UByteArraySerializer_0).y12 = function (_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.y12(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.am_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).z12 = function (_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.z12(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.am_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).a13 = function () {
    return _UByteArray___init__impl__ip4y9n(0);
  };
  protoOf(UByteArraySerializer_0).ow = function () {
    return new UByteArray(this.a13());
  };
  protoOf(UByteArraySerializer_0).b13 = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.er(this.fw_1, index).hq();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.e13(tmp$ret$0);
  };
  protoOf(UByteArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.b13(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.b13(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).f13 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.is(this.fw_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.pr(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UByteArraySerializer_0).qw = function (encoder, content, size) {
    return this.f13(encoder, content instanceof UByteArray ? content.am_1 : THROW_CCE(), size);
  };
  var UByteArraySerializer_instance;
  function UByteArraySerializer_getInstance() {
    if (UByteArraySerializer_instance == null)
      new UByteArraySerializer_0();
    return UByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_13(BooleanCompanionObject_instance));
  }
  protoOf(BooleanArraySerializer_0).i13 = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(BooleanArraySerializer_0).dv = function (_this__u8e3s4) {
    return this.i13((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).j13 = function (_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  };
  protoOf(BooleanArraySerializer_0).yt = function (_this__u8e3s4) {
    return this.j13((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).ow = function () {
    return booleanArray(0);
  };
  protoOf(BooleanArraySerializer_0).k13 = function (decoder, index, builder, checkIndex) {
    builder.n13(decoder.vq(this.fw_1, index));
  };
  protoOf(BooleanArraySerializer_0).ju = function (decoder, index, builder, checkIndex) {
    return this.k13(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).pw = function (decoder, index, builder, checkIndex) {
    return this.k13(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).o13 = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.zr(this.fw_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(BooleanArraySerializer_0).qw = function (encoder, content, size) {
    return this.o13(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.mz_1 = bufferWithData;
    this.nz_1 = bufferWithData.length;
    this.lw(10);
  }
  protoOf(CharArrayBuilder).hw = function () {
    return this.nz_1;
  };
  protoOf(CharArrayBuilder).lw = function (requiredCapacity) {
    if (this.mz_1.length < requiredCapacity)
      this.mz_1 = copyOf(this.mz_1, coerceAtLeast(requiredCapacity, imul(this.mz_1.length, 2)));
  };
  protoOf(CharArrayBuilder).oz = function (c) {
    this.sw();
    var tmp = this.mz_1;
    var _unary__edvuaz = this.nz_1;
    this.nz_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(CharArrayBuilder).jw = function () {
    return copyOf(this.mz_1, this.nz_1);
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.vz_1 = bufferWithData;
    this.wz_1 = bufferWithData.length;
    this.lw(10);
  }
  protoOf(DoubleArrayBuilder).hw = function () {
    return this.wz_1;
  };
  protoOf(DoubleArrayBuilder).lw = function (requiredCapacity) {
    if (this.vz_1.length < requiredCapacity)
      this.vz_1 = copyOf_0(this.vz_1, coerceAtLeast(requiredCapacity, imul(this.vz_1.length, 2)));
  };
  protoOf(DoubleArrayBuilder).xz = function (c) {
    this.sw();
    var tmp = this.vz_1;
    var _unary__edvuaz = this.wz_1;
    this.wz_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(DoubleArrayBuilder).jw = function () {
    return copyOf_0(this.vz_1, this.wz_1);
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.e10_1 = bufferWithData;
    this.f10_1 = bufferWithData.length;
    this.lw(10);
  }
  protoOf(FloatArrayBuilder).hw = function () {
    return this.f10_1;
  };
  protoOf(FloatArrayBuilder).lw = function (requiredCapacity) {
    if (this.e10_1.length < requiredCapacity)
      this.e10_1 = copyOf_1(this.e10_1, coerceAtLeast(requiredCapacity, imul(this.e10_1.length, 2)));
  };
  protoOf(FloatArrayBuilder).g10 = function (c) {
    this.sw();
    var tmp = this.e10_1;
    var _unary__edvuaz = this.f10_1;
    this.f10_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(FloatArrayBuilder).jw = function () {
    return copyOf_1(this.e10_1, this.f10_1);
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.n10_1 = bufferWithData;
    this.o10_1 = bufferWithData.length;
    this.lw(10);
  }
  protoOf(LongArrayBuilder).hw = function () {
    return this.o10_1;
  };
  protoOf(LongArrayBuilder).lw = function (requiredCapacity) {
    if (this.n10_1.length < requiredCapacity)
      this.n10_1 = copyOf_2(this.n10_1, coerceAtLeast(requiredCapacity, imul(this.n10_1.length, 2)));
  };
  protoOf(LongArrayBuilder).p10 = function (c) {
    this.sw();
    var tmp = this.n10_1;
    var _unary__edvuaz = this.o10_1;
    this.o10_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(LongArrayBuilder).jw = function () {
    return copyOf_2(this.n10_1, this.o10_1);
  };
  function ULongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.x10_1 = bufferWithData;
    this.y10_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.lw(10);
  }
  protoOf(ULongArrayBuilder).hw = function () {
    return this.y10_1;
  };
  protoOf(ULongArrayBuilder).lw = function (requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.x10_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.x10_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.x10_1), 2));
      tmp.x10_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
    }
  };
  protoOf(ULongArrayBuilder).z10 = function (c) {
    this.sw();
    var tmp = this.x10_1;
    var _unary__edvuaz = this.y10_1;
    this.y10_1 = _unary__edvuaz + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
  };
  protoOf(ULongArrayBuilder).p13 = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.x10_1;
    var newSize = this.y10_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(this_0), newSize));
  };
  protoOf(ULongArrayBuilder).jw = function () {
    return new ULongArray(this.p13());
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.g11_1 = bufferWithData;
    this.h11_1 = bufferWithData.length;
    this.lw(10);
  }
  protoOf(IntArrayBuilder).hw = function () {
    return this.h11_1;
  };
  protoOf(IntArrayBuilder).lw = function (requiredCapacity) {
    if (this.g11_1.length < requiredCapacity)
      this.g11_1 = copyOf_3(this.g11_1, coerceAtLeast(requiredCapacity, imul(this.g11_1.length, 2)));
  };
  protoOf(IntArrayBuilder).i11 = function (c) {
    this.sw();
    var tmp = this.g11_1;
    var _unary__edvuaz = this.h11_1;
    this.h11_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(IntArrayBuilder).jw = function () {
    return copyOf_3(this.g11_1, this.h11_1);
  };
  function UIntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.q11_1 = bufferWithData;
    this.r11_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.lw(10);
  }
  protoOf(UIntArrayBuilder).hw = function () {
    return this.r11_1;
  };
  protoOf(UIntArrayBuilder).lw = function (requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.q11_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.q11_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.q11_1), 2));
      tmp.q11_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
    }
  };
  protoOf(UIntArrayBuilder).s11 = function (c) {
    this.sw();
    var tmp = this.q11_1;
    var _unary__edvuaz = this.r11_1;
    this.r11_1 = _unary__edvuaz + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
  };
  protoOf(UIntArrayBuilder).q13 = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.q11_1;
    var newSize = this.r11_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(this_0), newSize));
  };
  protoOf(UIntArrayBuilder).jw = function () {
    return new UIntArray(this.q13());
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.z11_1 = bufferWithData;
    this.a12_1 = bufferWithData.length;
    this.lw(10);
  }
  protoOf(ShortArrayBuilder).hw = function () {
    return this.a12_1;
  };
  protoOf(ShortArrayBuilder).lw = function (requiredCapacity) {
    if (this.z11_1.length < requiredCapacity)
      this.z11_1 = copyOf_4(this.z11_1, coerceAtLeast(requiredCapacity, imul(this.z11_1.length, 2)));
  };
  protoOf(ShortArrayBuilder).b12 = function (c) {
    this.sw();
    var tmp = this.z11_1;
    var _unary__edvuaz = this.a12_1;
    this.a12_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(ShortArrayBuilder).jw = function () {
    return copyOf_4(this.z11_1, this.a12_1);
  };
  function UShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.j12_1 = bufferWithData;
    this.k12_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.lw(10);
  }
  protoOf(UShortArrayBuilder).hw = function () {
    return this.k12_1;
  };
  protoOf(UShortArrayBuilder).lw = function (requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.j12_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.j12_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.j12_1), 2));
      tmp.j12_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
    }
  };
  protoOf(UShortArrayBuilder).l12 = function (c) {
    this.sw();
    var tmp = this.j12_1;
    var _unary__edvuaz = this.k12_1;
    this.k12_1 = _unary__edvuaz + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
  };
  protoOf(UShortArrayBuilder).r13 = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.j12_1;
    var newSize = this.k12_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(this_0), newSize));
  };
  protoOf(UShortArrayBuilder).jw = function () {
    return new UShortArray(this.r13());
  };
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.s12_1 = bufferWithData;
    this.t12_1 = bufferWithData.length;
    this.lw(10);
  }
  protoOf(ByteArrayBuilder).hw = function () {
    return this.t12_1;
  };
  protoOf(ByteArrayBuilder).lw = function (requiredCapacity) {
    if (this.s12_1.length < requiredCapacity)
      this.s12_1 = copyOf_5(this.s12_1, coerceAtLeast(requiredCapacity, imul(this.s12_1.length, 2)));
  };
  protoOf(ByteArrayBuilder).u12 = function (c) {
    this.sw();
    var tmp = this.s12_1;
    var _unary__edvuaz = this.t12_1;
    this.t12_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(ByteArrayBuilder).jw = function () {
    return copyOf_5(this.s12_1, this.t12_1);
  };
  function UByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.c13_1 = bufferWithData;
    this.d13_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.lw(10);
  }
  protoOf(UByteArrayBuilder).hw = function () {
    return this.d13_1;
  };
  protoOf(UByteArrayBuilder).lw = function (requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.c13_1) < requiredCapacity) {
      var tmp = this;
      // Inline function 'kotlin.collections.copyOf' call
      var this_0 = this.c13_1;
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.c13_1), 2));
      tmp.c13_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
    }
  };
  protoOf(UByteArrayBuilder).e13 = function (c) {
    this.sw();
    var tmp = this.c13_1;
    var _unary__edvuaz = this.d13_1;
    this.d13_1 = _unary__edvuaz + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
  };
  protoOf(UByteArrayBuilder).s13 = function () {
    // Inline function 'kotlin.collections.copyOf' call
    var this_0 = this.c13_1;
    var newSize = this.d13_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(this_0), newSize));
  };
  protoOf(UByteArrayBuilder).jw = function () {
    return new UByteArray(this.s13());
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.l13_1 = bufferWithData;
    this.m13_1 = bufferWithData.length;
    this.lw(10);
  }
  protoOf(BooleanArrayBuilder).hw = function () {
    return this.m13_1;
  };
  protoOf(BooleanArrayBuilder).lw = function (requiredCapacity) {
    if (this.l13_1.length < requiredCapacity)
      this.l13_1 = copyOf_6(this.l13_1, coerceAtLeast(requiredCapacity, imul(this.l13_1.length, 2)));
  };
  protoOf(BooleanArrayBuilder).n13 = function (c) {
    this.sw();
    var tmp = this.l13_1;
    var _unary__edvuaz = this.m13_1;
    this.m13_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(BooleanArrayBuilder).jw = function () {
    return copyOf_6(this.l13_1, this.m13_1);
  };
  function get_BUILTIN_SERIALIZERS() {
    _init_properties_Primitives_kt__k0eto4();
    return BUILTIN_SERIALIZERS;
  }
  var BUILTIN_SERIALIZERS;
  function builtinSerializerOrNull(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    var tmp = get_BUILTIN_SERIALIZERS().b2(_this__u8e3s4);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function StringSerializer() {
    StringSerializer_instance = this;
    this.t13_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  protoOf(StringSerializer).nn = function () {
    return this.t13_1;
  };
  protoOf(StringSerializer).u13 = function (encoder, value) {
    return encoder.wr(value);
  };
  protoOf(StringSerializer).on = function (encoder, value) {
    return this.u13(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(StringSerializer).pn = function (decoder) {
    return decoder.oq();
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function CharSerializer() {
    CharSerializer_instance = this;
    this.v13_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  protoOf(CharSerializer).nn = function () {
    return this.v13_1;
  };
  protoOf(CharSerializer).w13 = function (encoder, value) {
    return encoder.vr(value);
  };
  protoOf(CharSerializer).on = function (encoder, value) {
    return this.w13(encoder, value instanceof Char ? value.l1_1 : THROW_CCE());
  };
  protoOf(CharSerializer).x13 = function (decoder) {
    return decoder.nq();
  };
  protoOf(CharSerializer).pn = function (decoder) {
    return new Char(this.x13(decoder));
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this.y13_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  protoOf(DoubleSerializer).nn = function () {
    return this.y13_1;
  };
  protoOf(DoubleSerializer).z13 = function (encoder, value) {
    return encoder.ur(value);
  };
  protoOf(DoubleSerializer).on = function (encoder, value) {
    return this.z13(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(DoubleSerializer).pn = function (decoder) {
    return decoder.mq();
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this.a14_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  protoOf(FloatSerializer).nn = function () {
    return this.a14_1;
  };
  protoOf(FloatSerializer).b14 = function (encoder, value) {
    return encoder.tr(value);
  };
  protoOf(FloatSerializer).on = function (encoder, value) {
    return this.b14(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatSerializer).pn = function (decoder) {
    return decoder.lq();
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this.c14_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  protoOf(LongSerializer).nn = function () {
    return this.c14_1;
  };
  protoOf(LongSerializer).d14 = function (encoder, value) {
    return encoder.sr(value);
  };
  protoOf(LongSerializer).on = function (encoder, value) {
    return this.d14(encoder, value instanceof Long ? value : THROW_CCE());
  };
  protoOf(LongSerializer).pn = function (decoder) {
    return decoder.kq();
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this.e14_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  protoOf(IntSerializer).nn = function () {
    return this.e14_1;
  };
  protoOf(IntSerializer).f14 = function (encoder, value) {
    return encoder.rr(value);
  };
  protoOf(IntSerializer).on = function (encoder, value) {
    return this.f14(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntSerializer).pn = function (decoder) {
    return decoder.jq();
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this.g14_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  protoOf(ShortSerializer).nn = function () {
    return this.g14_1;
  };
  protoOf(ShortSerializer).h14 = function (encoder, value) {
    return encoder.qr(value);
  };
  protoOf(ShortSerializer).on = function (encoder, value) {
    return this.h14(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ShortSerializer).pn = function (decoder) {
    return decoder.iq();
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this.i14_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  protoOf(ByteSerializer).nn = function () {
    return this.i14_1;
  };
  protoOf(ByteSerializer).j14 = function (encoder, value) {
    return encoder.pr(value);
  };
  protoOf(ByteSerializer).on = function (encoder, value) {
    return this.j14(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ByteSerializer).pn = function (decoder) {
    return decoder.hq();
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this.k14_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  protoOf(BooleanSerializer).nn = function () {
    return this.k14_1;
  };
  protoOf(BooleanSerializer).l14 = function (encoder, value) {
    return encoder.or(value);
  };
  protoOf(BooleanSerializer).on = function (encoder, value) {
    return this.l14(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(BooleanSerializer).pn = function (decoder) {
    return decoder.gq();
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this.m14_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
  }
  protoOf(UnitSerializer).nn = function () {
    return this.m14_1.nn();
  };
  protoOf(UnitSerializer).n14 = function (encoder, value) {
    this.m14_1.do(encoder, Unit_instance);
  };
  protoOf(UnitSerializer).on = function (encoder, value) {
    return this.n14(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  protoOf(UnitSerializer).o14 = function (decoder) {
    this.m14_1.pn(decoder);
  };
  protoOf(UnitSerializer).pn = function (decoder) {
    this.o14(decoder);
    return Unit_instance;
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  function error_0($this) {
    throw IllegalStateException_init_$Create$('Primitive descriptor does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this.p14_1 = serialName;
    this.q14_1 = kind;
  }
  protoOf(PrimitiveSerialDescriptor_0).wo = function () {
    return this.p14_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).xo = function () {
    return this.q14_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).zo = function () {
    return 0;
  };
  protoOf(PrimitiveSerialDescriptor_0).bp = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).cp = function (name) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).fp = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).ep = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).dp = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
    return 'PrimitiveDescriptor(' + this.p14_1 + ')';
  };
  protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor_0))
      return false;
    if (this.p14_1 === other.p14_1 && equals(this.q14_1, other.q14_1))
      return true;
    return false;
  };
  protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
    return getStringHashCode(this.p14_1) + imul(31, this.q14_1.hashCode()) | 0;
  };
  function PrimitiveDescriptorSafe(serialName, kind) {
    _init_properties_Primitives_kt__k0eto4();
    checkName(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function checkName(serialName) {
    _init_properties_Primitives_kt__k0eto4();
    var values = get_BUILTIN_SERIALIZERS().d2();
    var _iterator__ex2g4s = values.g();
    while (_iterator__ex2g4s.h()) {
      var primitive = _iterator__ex2g4s.i();
      var primitiveName = primitive.nn().wo();
      if (serialName === primitiveName) {
        throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).cb() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }
    }
  }
  var properties_initialized_Primitives_kt_6dpii6;
  function _init_properties_Primitives_kt__k0eto4() {
    if (!properties_initialized_Primitives_kt_6dpii6) {
      properties_initialized_Primitives_kt_6dpii6 = true;
      BUILTIN_SERIALIZERS = initBuiltins();
    }
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  protoOf(NamedValueDecoder).t14 = function (_this__u8e3s4, index) {
    return this.v14(this.u14(_this__u8e3s4, index));
  };
  protoOf(NamedValueDecoder).v14 = function (nestedName) {
    var tmp0_elvis_lhs = this.y14();
    return this.z14(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueDecoder).u14 = function (descriptor, index) {
    return descriptor.bp(index);
  };
  protoOf(NamedValueDecoder).z14 = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  protoOf(NamedValueDecoder).a15 = function () {
    return this.w14_1.k() ? '$' : joinToString(this.w14_1, '.', '$.');
  };
  function tagBlock($this, tag, block) {
    $this.o15(tag);
    var r = block();
    if (!$this.x14_1) {
      $this.p15();
    }
    $this.x14_1 = false;
    return r;
  }
  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.rq($deserializer, $previousValue);
    };
  }
  function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
      var this_0 = this$0;
      var isNullabilitySupported = $deserializer.nn().so();
      var tmp;
      if (isNullabilitySupported || this_0.eq()) {
        // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeNullableSerializableElement.<anonymous>.<anonymous>' call
        tmp = this$0.rq($deserializer, $previousValue);
      } else {
        tmp = this_0.fq();
      }
      return tmp;
    };
  }
  function TaggedDecoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.w14_1 = ArrayList_init_$Create$_0();
    this.x14_1 = false;
  }
  protoOf(TaggedDecoder).jo = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedDecoder).b15 = function (tag) {
    throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(TaggedDecoder).c15 = function (tag) {
    return true;
  };
  protoOf(TaggedDecoder).d15 = function (tag) {
    var tmp = this.b15(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).e15 = function (tag) {
    var tmp = this.b15(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).f15 = function (tag) {
    var tmp = this.b15(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).g15 = function (tag) {
    var tmp = this.b15(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).h15 = function (tag) {
    var tmp = this.b15(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).i15 = function (tag) {
    var tmp = this.b15(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).j15 = function (tag) {
    var tmp = this.b15(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).k15 = function (tag) {
    var tmp = this.b15(tag);
    return tmp instanceof Char ? tmp.l1_1 : THROW_CCE();
  };
  protoOf(TaggedDecoder).l15 = function (tag) {
    var tmp = this.b15(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).m15 = function (tag, enumDescriptor) {
    var tmp = this.b15(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).n15 = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.TaggedDecoder.decodeTaggedInline.<anonymous>' call
    this.o15(tag);
    return this;
  };
  protoOf(TaggedDecoder).rq = function (deserializer, previousValue) {
    return this.sq(deserializer);
  };
  protoOf(TaggedDecoder).qq = function (descriptor) {
    return this.n15(this.p15(), descriptor);
  };
  protoOf(TaggedDecoder).eq = function () {
    var tmp0_elvis_lhs = this.y14();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.c15(currentTag);
  };
  protoOf(TaggedDecoder).fq = function () {
    return null;
  };
  protoOf(TaggedDecoder).gq = function () {
    return this.d15(this.p15());
  };
  protoOf(TaggedDecoder).hq = function () {
    return this.e15(this.p15());
  };
  protoOf(TaggedDecoder).iq = function () {
    return this.f15(this.p15());
  };
  protoOf(TaggedDecoder).jq = function () {
    return this.g15(this.p15());
  };
  protoOf(TaggedDecoder).kq = function () {
    return this.h15(this.p15());
  };
  protoOf(TaggedDecoder).lq = function () {
    return this.i15(this.p15());
  };
  protoOf(TaggedDecoder).mq = function () {
    return this.j15(this.p15());
  };
  protoOf(TaggedDecoder).nq = function () {
    return this.k15(this.p15());
  };
  protoOf(TaggedDecoder).oq = function () {
    return this.l15(this.p15());
  };
  protoOf(TaggedDecoder).pq = function (enumDescriptor) {
    return this.m15(this.p15(), enumDescriptor);
  };
  protoOf(TaggedDecoder).tq = function (descriptor) {
    return this;
  };
  protoOf(TaggedDecoder).uq = function (descriptor) {
  };
  protoOf(TaggedDecoder).vq = function (descriptor, index) {
    return this.d15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).wq = function (descriptor, index) {
    return this.e15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).xq = function (descriptor, index) {
    return this.f15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).yq = function (descriptor, index) {
    return this.g15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).zq = function (descriptor, index) {
    return this.h15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).ar = function (descriptor, index) {
    return this.i15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).br = function (descriptor, index) {
    return this.j15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).cr = function (descriptor, index) {
    return this.k15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).dr = function (descriptor, index) {
    return this.l15(this.t14(descriptor, index));
  };
  protoOf(TaggedDecoder).er = function (descriptor, index) {
    return this.n15(this.t14(descriptor, index), descriptor.ep(index));
  };
  protoOf(TaggedDecoder).fr = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.t14(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).hr = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.t14(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).y14 = function () {
    return lastOrNull(this.w14_1);
  };
  protoOf(TaggedDecoder).o15 = function (name) {
    this.w14_1.e(name);
  };
  protoOf(TaggedDecoder).p15 = function () {
    var r = this.w14_1.j2(get_lastIndex_0(this.w14_1));
    this.x14_1 = true;
    return r;
  };
  function get_NULL() {
    _init_properties_Tuples_kt__dz0qyd();
    return NULL;
  }
  var NULL;
  function MapEntry(key, value) {
    this.q15_1 = key;
    this.r15_1 = value;
  }
  protoOf(MapEntry).v = function () {
    return this.q15_1;
  };
  protoOf(MapEntry).w = function () {
    return this.r15_1;
  };
  protoOf(MapEntry).toString = function () {
    return 'MapEntry(key=' + toString_0(this.q15_1) + ', value=' + toString_0(this.r15_1) + ')';
  };
  protoOf(MapEntry).hashCode = function () {
    var result = this.q15_1 == null ? 0 : hashCode(this.q15_1);
    result = imul(result, 31) + (this.r15_1 == null ? 0 : hashCode(this.r15_1)) | 0;
    return result;
  };
  protoOf(MapEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.q15_1, tmp0_other_with_cast.q15_1))
      return false;
    if (!equals(this.r15_1, tmp0_other_with_cast.r15_1))
      return false;
    return true;
  };
  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.yn('key', $keySerializer.nn());
      $this$buildSerialDescriptor.yn('value', $valueSerializer.nn());
      return Unit_instance;
    };
  }
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.u15_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(MapEntrySerializer_0).nn = function () {
    return this.u15_1;
  };
  protoOf(MapEntrySerializer_0).v15 = function (_this__u8e3s4) {
    return _this__u8e3s4.v();
  };
  protoOf(MapEntrySerializer_0).w15 = function (_this__u8e3s4) {
    return this.v15((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).x15 = function (_this__u8e3s4) {
    return _this__u8e3s4.w();
  };
  protoOf(MapEntrySerializer_0).y15 = function (_this__u8e3s4) {
    return this.x15((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).z15 = function (key, value) {
    return new MapEntry(key, value);
  };
  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.yn('first', $keySerializer.nn());
      $this$buildClassSerialDescriptor.yn('second', $valueSerializer.nn());
      return Unit_instance;
    };
  }
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    tmp.f16_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(PairSerializer_0).nn = function () {
    return this.f16_1;
  };
  protoOf(PairSerializer_0).g16 = function (_this__u8e3s4) {
    return _this__u8e3s4.pg_1;
  };
  protoOf(PairSerializer_0).w15 = function (_this__u8e3s4) {
    return this.g16(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).h16 = function (_this__u8e3s4) {
    return _this__u8e3s4.qg_1;
  };
  protoOf(PairSerializer_0).y15 = function (_this__u8e3s4) {
    return this.h16(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).z15 = function (key, value) {
    return to(key, value);
  };
  function decodeSequentially_1($this, composite) {
    var a = composite.gr($this.l16_1, 0, $this.i16_1);
    var b = composite.gr($this.l16_1, 1, $this.j16_1);
    var c = composite.gr($this.l16_1, 2, $this.k16_1);
    composite.uq($this.l16_1);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = get_NULL();
    var b = get_NULL();
    var c = get_NULL();
    mainLoop: while (true) {
      var index = composite.jr($this.l16_1);
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          a = composite.gr($this.l16_1, 0, $this.i16_1);
          break;
        case 1:
          b = composite.gr($this.l16_1, 1, $this.j16_1);
          break;
        case 2:
          c = composite.gr($this.l16_1, 2, $this.k16_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Unexpected index ' + index);
      }
    }
    composite.uq($this.l16_1);
    if (a === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'first' is missing");
    if (b === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'second' is missing");
    if (c === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'third' is missing");
    var tmp = (a == null ? true : !(a == null)) ? a : THROW_CCE();
    var tmp_0 = (b == null ? true : !(b == null)) ? b : THROW_CCE();
    return new Triple(tmp, tmp_0, (c == null ? true : !(c == null)) ? c : THROW_CCE());
  }
  function TripleSerializer$descriptor$lambda(this$0) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.yn('first', this$0.i16_1.nn());
      $this$buildClassSerialDescriptor.yn('second', this$0.j16_1.nn());
      $this$buildClassSerialDescriptor.yn('third', this$0.k16_1.nn());
      return Unit_instance;
    };
  }
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this.i16_1 = aSerializer;
    this.j16_1 = bSerializer;
    this.k16_1 = cSerializer;
    var tmp = this;
    tmp.l16_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  protoOf(TripleSerializer_0).nn = function () {
    return this.l16_1;
  };
  protoOf(TripleSerializer_0).m16 = function (encoder, value) {
    var structuredEncoder = encoder.tq(this.l16_1);
    structuredEncoder.js(this.l16_1, 0, this.i16_1, value.el_1);
    structuredEncoder.js(this.l16_1, 1, this.j16_1, value.fl_1);
    structuredEncoder.js(this.l16_1, 2, this.k16_1, value.gl_1);
    structuredEncoder.uq(this.l16_1);
  };
  protoOf(TripleSerializer_0).on = function (encoder, value) {
    return this.m16(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  protoOf(TripleSerializer_0).pn = function (decoder) {
    var composite = decoder.tq(this.l16_1);
    if (composite.ir()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this.a16_1 = keySerializer;
    this.b16_1 = valueSerializer;
  }
  protoOf(KeyValueSerializer).c16 = function (encoder, value) {
    var structuredEncoder = encoder.tq(this.nn());
    structuredEncoder.js(this.nn(), 0, this.a16_1, this.w15(value));
    structuredEncoder.js(this.nn(), 1, this.b16_1, this.y15(value));
    structuredEncoder.uq(this.nn());
  };
  protoOf(KeyValueSerializer).on = function (encoder, value) {
    return this.c16(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(KeyValueSerializer).pn = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.nn();
    var composite = decoder.tq(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
      if (composite.ir()) {
        var key = composite.gr(this.nn(), 0, this.a16_1);
        var value = composite.gr(this.nn(), 1, this.b16_1);
        tmp$ret$0 = this.z15(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.jr(this.nn());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.gr(this.nn(), 0, this.a16_1);
            break;
          case 1:
            value_0 = composite.gr(this.nn(), 1, this.b16_1);
            break;
          default:
            throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'value' is missing");
      var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.z15(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.uq(descriptor);
    return result;
  };
  var properties_initialized_Tuples_kt_3vs7ar;
  function _init_properties_Tuples_kt__dz0qyd() {
    if (!properties_initialized_Tuples_kt_3vs7ar) {
      properties_initialized_Tuples_kt_3vs7ar = true;
      NULL = new Object();
    }
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this.n16_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_5(Companion_getInstance_2()));
  }
  protoOf(ULongSerializer).nn = function () {
    return this.n16_1;
  };
  protoOf(ULongSerializer).o16 = function (encoder, value) {
    var tmp = encoder.yr(this.n16_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.sr(tmp$ret$0);
  };
  protoOf(ULongSerializer).on = function (encoder, value) {
    return this.o16(encoder, value instanceof ULong ? value.tm_1 : THROW_CCE());
  };
  protoOf(ULongSerializer).p16 = function (decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.qq(this.n16_1).kq();
    return _ULong___init__impl__c78o9k(this_0);
  };
  protoOf(ULongSerializer).pn = function (decoder) {
    return new ULong(this.p16(decoder));
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this.q16_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_7(IntCompanionObject_instance));
  }
  protoOf(UIntSerializer).nn = function () {
    return this.q16_1;
  };
  protoOf(UIntSerializer).r16 = function (encoder, value) {
    var tmp = encoder.yr(this.q16_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.rr(tmp$ret$0);
  };
  protoOf(UIntSerializer).on = function (encoder, value) {
    return this.r16(encoder, value instanceof UInt ? value.hm_1 : THROW_CCE());
  };
  protoOf(UIntSerializer).s16 = function (decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.qq(this.q16_1).jq();
    return _UInt___init__impl__l7qpdl(this_0);
  };
  protoOf(UIntSerializer).pn = function (decoder) {
    return new UInt(this.s16(decoder));
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this.t16_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_9(ShortCompanionObject_instance));
  }
  protoOf(UShortSerializer).nn = function () {
    return this.t16_1;
  };
  protoOf(UShortSerializer).u16 = function (encoder, value) {
    var tmp = encoder.yr(this.t16_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.qr(tmp$ret$0);
  };
  protoOf(UShortSerializer).on = function (encoder, value) {
    return this.u16(encoder, value instanceof UShort ? value.fn_1 : THROW_CCE());
  };
  protoOf(UShortSerializer).v16 = function (decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.qq(this.t16_1).iq();
    return _UShort___init__impl__jigrne(this_0);
  };
  protoOf(UShortSerializer).pn = function (decoder) {
    return new UShort(this.v16(decoder));
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this.w16_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_11(ByteCompanionObject_instance));
  }
  protoOf(UByteSerializer).nn = function () {
    return this.w16_1;
  };
  protoOf(UByteSerializer).x16 = function (encoder, value) {
    var tmp = encoder.yr(this.w16_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.pr(tmp$ret$0);
  };
  protoOf(UByteSerializer).on = function (encoder, value) {
    return this.x16(encoder, value instanceof UByte ? value.vl_1 : THROW_CCE());
  };
  protoOf(UByteSerializer).y16 = function (decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.qq(this.w16_1).hq();
    return _UByte___init__impl__g9hnc4(this_0);
  };
  protoOf(UByteSerializer).pn = function (decoder) {
    return new UByte(this.y16(decoder));
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function get_EmptySerializersModuleLegacyJs() {
    _init_properties_SerializersModule_kt__u78ha3();
    return EmptySerializersModule;
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  protoOf(SerializersModule).oo = function (kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.po(kClass, typeArgumentsSerializers) : $super.po.call(this, kClass, typeArgumentsSerializers);
  };
  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
    SerializersModule.call(this);
    this.a17_1 = class2ContextualFactory;
    this.b17_1 = polyBase2Serializers;
    this.c17_1 = polyBase2DefaultSerializerProvider;
    this.d17_1 = polyBase2NamedSerializers;
    this.e17_1 = polyBase2DefaultDeserializerProvider;
    this.f17_1 = hasInterfaceContextualSerializers;
  }
  protoOf(SerialModuleImpl).no = function () {
    return this.f17_1;
  };
  protoOf(SerialModuleImpl).rs = function (baseClass, value) {
    if (!baseClass.db(value))
      return null;
    var tmp0_safe_receiver = this.b17_1.b2(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b2(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.c17_1.b2(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  };
  protoOf(SerialModuleImpl).qs = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.d17_1.b2(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).b2(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.e17_1.b2(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  protoOf(SerialModuleImpl).po = function (kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.a17_1.b2(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g17(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  };
  protoOf(SerialModuleImpl).z16 = function (collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this.a17_1.u().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.v();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.w();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.j17_1;
        collector.k17(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.i17(kclass, serial.h17_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_0 = this.b17_1.u().g();
    while (tmp0_iterator_0.h()) {
      var element_0 = tmp0_iterator_0.i();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.v();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.w();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = classMap.u().g();
      while (tmp0_iterator_1.h()) {
        var element_1 = tmp0_iterator_1.i();
        // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.v();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.w();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$9 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.l17(tmp_1, tmp_2, tmp$ret$9);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_2 = this.c17_1.u().g();
    while (tmp0_iterator_2.h()) {
      var element_2 = tmp0_iterator_2.i();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.v();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.w();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.m17(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator_3 = this.e17_1.u().g();
    while (tmp0_iterator_3.h()) {
      var element_3 = tmp0_iterator_3.i();
      // Inline function 'kotlinx.serialization.modules.SerialModuleImpl.dumpTo.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.v();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.w();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.n17(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  };
  function Argless() {
  }
  function WithTypeArguments() {
  }
  function ContextualProvider() {
  }
  var properties_initialized_SerializersModule_kt_fjigjn;
  function _init_properties_SerializersModule_kt__u78ha3() {
    if (!properties_initialized_SerializersModule_kt_fjigjn) {
      properties_initialized_SerializersModule_kt_fjigjn = true;
      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
    }
  }
  function EmptySerializersModule_0() {
    return get_EmptySerializersModuleLegacyJs();
  }
  function SerializersModuleCollector$contextual$lambda($serializer) {
    return function (it) {
      return $serializer;
    };
  }
  function SerializersModuleCollector() {
  }
  function SerializableWith(serializer) {
    this.o17_1 = serializer;
  }
  protoOf(SerializableWith).equals = function (other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.o17_1.equals(tmp0_other_with_cast.o17_1))
      return false;
    return true;
  };
  protoOf(SerializableWith).hashCode = function () {
    return imul(getStringHashCode('serializer'), 127) ^ this.o17_1.hashCode();
  };
  protoOf(SerializableWith).toString = function () {
    return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.o17_1) + ')';
  };
  function createCache(factory) {
    return new createCache$1(factory);
  }
  function createParametrizedCache(factory) {
    return new createParametrizedCache$1(factory);
  }
  function isInterface_0(_this__u8e3s4) {
    return get_isInterface(_this__u8e3s4);
  }
  function initBuiltins() {
    return mapOf([to(PrimitiveClasses_getInstance().ic(), serializer_1(StringCompanionObject_instance)), to(getKClass(Char), serializer_2(Companion_getInstance_1())), to(PrimitiveClasses_getInstance().lc(), CharArraySerializer()), to(PrimitiveClasses_getInstance().gc(), serializer_3(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().rc(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().fc(), serializer_4(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().qc(), FloatArraySerializer()), to(getKClass(Long), serializer_5(Companion_getInstance_2())), to(PrimitiveClasses_getInstance().pc(), LongArraySerializer()), to(getKClass(ULong), serializer_6(Companion_getInstance_3())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().ec(), serializer_7(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().oc(), IntArraySerializer()), to(getKClass(UInt), serializer_8(Companion_getInstance_4())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().dc(), serializer_9(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().nc(), ShortArraySerializer()), to(getKClass(UShort), serializer_10(Companion_getInstance_5())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().cc(), serializer_11(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().mc(), ByteArraySerializer()), to(getKClass(UByte), serializer_12(Companion_getInstance_6())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().bc(), serializer_13(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().kc(), BooleanArraySerializer()), to(getKClass(Unit), serializer_14(Unit_instance)), to(PrimitiveClasses_getInstance().ac(), NothingSerializer()), to(getKClass(Duration), serializer_15(Companion_getInstance())), to(getKClass(Uuid), serializer_16(Companion_getInstance_0()))]);
  }
  function get_isInterface(_this__u8e3s4) {
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().ac())
      return false;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
  }
  function compiledSerializerImpl(_this__u8e3s4) {
    var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      if (_this__u8e3s4 === PrimitiveClasses_getInstance().ac()) {
        tmp_0 = NothingSerializer_getInstance();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_safe_receiver = get_js(_this__u8e3s4).Companion;
        tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.serializer();
      }
      var tmp_1 = tmp_0;
      tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance().hc());
  }
  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
    var tmp;
    try {
      // Inline function 'kotlin.reflect.findAssociatedObject' call
      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.gz(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      var e = $p;
      tmp_2 = null;
      tmp = tmp_2;
    }
    return tmp;
  }
  function toNativeArrayImpl(_this__u8e3s4, eClass) {
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(_this__u8e3s4);
  }
  function getChecked(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function getChecked_0(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function createCache$1($factory) {
    this.p17_1 = $factory;
  }
  protoOf(createCache$1).qo = function (key) {
    return this.p17_1(key);
  };
  function createParametrizedCache$1($factory) {
    this.q17_1 = $factory;
  }
  protoOf(createParametrizedCache$1).ro = function (key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      // Inline function 'kotlinx.serialization.internal.<no name provided>.get.<anonymous>' call
      var value = this.q17_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  //region block: post-declaration
  protoOf(SerialDescriptorImpl).so = get_isNullable;
  protoOf(SerialDescriptorImpl).yo = get_isInline;
  protoOf(AbstractDecoder).gr = decodeSerializableElement$default;
  protoOf(AbstractDecoder).sq = decodeSerializableValue;
  protoOf(AbstractDecoder).ir = decodeSequentially;
  protoOf(AbstractDecoder).kr = decodeCollectionSize;
  protoOf(AbstractEncoder).ns = encodeNotNullMark;
  protoOf(AbstractEncoder).os = beginCollection;
  protoOf(AbstractEncoder).ks = encodeSerializableValue;
  protoOf(AbstractEncoder).ms = encodeNullableSerializableValue;
  protoOf(AbstractEncoder).ps = shouldEncodeElementDefault;
  protoOf(ListLikeDescriptor).so = get_isNullable;
  protoOf(ListLikeDescriptor).yo = get_isInline;
  protoOf(ListLikeDescriptor).ap = get_annotations;
  protoOf(MapLikeDescriptor).so = get_isNullable;
  protoOf(MapLikeDescriptor).yo = get_isInline;
  protoOf(MapLikeDescriptor).ap = get_annotations;
  protoOf(PluginGeneratedSerialDescriptor).so = get_isNullable;
  protoOf(PluginGeneratedSerialDescriptor).yo = get_isInline;
  protoOf(InlinePrimitiveDescriptor$1).wy = typeParametersSerializers;
  protoOf(NothingSerialDescriptor).so = get_isNullable;
  protoOf(NothingSerialDescriptor).yo = get_isInline;
  protoOf(NothingSerialDescriptor).ap = get_annotations;
  protoOf(PrimitiveSerialDescriptor_0).so = get_isNullable;
  protoOf(PrimitiveSerialDescriptor_0).yo = get_isInline;
  protoOf(PrimitiveSerialDescriptor_0).ap = get_annotations;
  protoOf(TaggedDecoder).gr = decodeSerializableElement$default;
  protoOf(TaggedDecoder).sq = decodeSerializableValue;
  protoOf(TaggedDecoder).ir = decodeSequentially;
  protoOf(TaggedDecoder).kr = decodeCollectionSize;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = SerializationException_init_$Init$_0;
  _.$_$.b = SerializationException_init_$Create$_0;
  _.$_$.c = UnknownFieldException_init_$Create$;
  _.$_$.d = SEALED_getInstance;
  _.$_$.e = STRING_getInstance;
  _.$_$.f = CONTEXTUAL_getInstance;
  _.$_$.g = ENUM_getInstance;
  _.$_$.h = CLASS_getInstance;
  _.$_$.i = LIST_getInstance;
  _.$_$.j = MAP_getInstance;
  _.$_$.k = OBJECT_getInstance;
  _.$_$.l = BooleanSerializer_getInstance;
  _.$_$.m = DoubleSerializer_getInstance;
  _.$_$.n = IntSerializer_getInstance;
  _.$_$.o = LongSerializer_getInstance;
  _.$_$.p = StringSerializer_getInstance;
  _.$_$.q = ListSerializer;
  _.$_$.r = MapSerializer;
  _.$_$.s = SetSerializer;
  _.$_$.t = get_nullable;
  _.$_$.u = serializer_1;
  _.$_$.v = serializer_10;
  _.$_$.w = serializer_8;
  _.$_$.x = serializer_12;
  _.$_$.y = serializer_6;
  _.$_$.z = PolymorphicKind;
  _.$_$.a1 = PrimitiveKind;
  _.$_$.b1 = PrimitiveSerialDescriptor;
  _.$_$.c1 = get_annotations;
  _.$_$.d1 = get_isInline;
  _.$_$.e1 = get_isNullable;
  _.$_$.f1 = SerialDescriptor;
  _.$_$.g1 = ENUM;
  _.$_$.h1 = buildSerialDescriptor;
  _.$_$.i1 = getContextualDescriptor;
  _.$_$.j1 = AbstractDecoder;
  _.$_$.k1 = AbstractEncoder;
  _.$_$.l1 = CompositeDecoder;
  _.$_$.m1 = CompositeEncoder;
  _.$_$.n1 = Decoder;
  _.$_$.o1 = Encoder;
  _.$_$.p1 = AbstractPolymorphicSerializer;
  _.$_$.q1 = ArrayListSerializer;
  _.$_$.r1 = ElementMarker;
  _.$_$.s1 = typeParametersSerializers;
  _.$_$.t1 = GeneratedSerializer;
  _.$_$.u1 = InlinePrimitiveDescriptor;
  _.$_$.v1 = LinkedHashMapSerializer;
  _.$_$.w1 = LinkedHashSetSerializer;
  _.$_$.x1 = NamedValueDecoder;
  _.$_$.y1 = PluginGeneratedSerialDescriptor;
  _.$_$.z1 = SerializerFactory;
  _.$_$.a2 = createSimpleEnumSerializer;
  _.$_$.b2 = jsonCachedSerialNames;
  _.$_$.c2 = throwMissingFieldException;
  _.$_$.d2 = EmptySerializersModule_0;
  _.$_$.e2 = contextual;
  _.$_$.f2 = SerializersModuleCollector;
  _.$_$.g2 = BinaryFormat;
  _.$_$.h2 = DeserializationStrategy;
  _.$_$.i2 = KSerializer;
  _.$_$.j2 = MissingFieldException;
  _.$_$.k2 = SealedClassSerializer;
  _.$_$.l2 = SerializationException;
  _.$_$.m2 = SerializationStrategy;
  _.$_$.n2 = StringFormat;
  _.$_$.o2 = findPolymorphicSerializer_0;
  _.$_$.p2 = findPolymorphicSerializer;
  _.$_$.q2 = serializerOrNull_0;
  _.$_$.r2 = serializer_0;
  _.$_$.s2 = serializer;
  //endregion
  return _;
}));
